// @ts-nocheck
/* eslint-disable */
import React, { useMemo, useEffect, useState } from 'react';
import useAppStore from '../store/index'; 
import useAdminStore from '../store/adminStore';
import { useCalculationsSelector } from '../store/selectors/calculations';
import { MonatsDaten, MitarbeiterStatus } from '../store/types'; 
import PasswordPrompt from '../components/PasswordPrompt';
import EditableField from '../components/EditableField';
import ExecutiveSummaryModal from '../components/ExecutiveSummaryModal';
import FestsetzungsHistorieModal from '../components/FestsetzungsHistorieModal';
import FestsetzungsHistorieModalHJ2 from '../components/FestsetzungsHistorieModalHJ2';
import { isLegacyLockedMetrics, resolveLeistungLockedMetricsIndex } from '../store/slices/coreDataSlice';
import { isSoloModeActive } from '../utils/soloMode';
import { useTeamBonus } from '../store/hooks/useTeamBonus';
import {
    computeEmployeeLeistung,
    normalizeMonthsForMA,
} from '../utils/leistungCalculationHelper';
import { isHj1ClientLocked } from '../utils/hjLock';
import Hj1MandantLockBanner from '../components/Hj1MandantLockBanner';

// ============================================================================
// STYLES: EXECUTIVE CARBON EDITION
// ============================================================================
const DashboardStyles = () => (
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700;800&family=Inter:wght@300;400;600;800&display=swap');

        .font-sans { font-family: 'Inter', sans-serif; }
        .font-mono-numbers { font-family: 'JetBrains Mono', monospace; font-variant-numeric: tabular-nums; }
        
        .bg-deep-space { background-color: #030303; }
        html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
        html:not(.dark) .carbon-weave-bg { background-color: var(--pe-bg-elevated); background-image: none; }
        html:not(.dark) .carbon-panel { background-color: var(--pe-bg-card); border-color: var(--pe-border-subtle); }
        html:not(.dark) .carbon-panel::after { background: none; }
        .text-phantom-gold { color: #E6C299; }
        
        .carbon-weave-bg {
            background-color: #030303;
            background-image: 
                radial-gradient(circle at 100% 150%, #030303 24%, #0a0a0a 24%, #0a0a0a 28%, #030303 28%, #030303 36%, #0a0a0a 36%, #0a0a0a 40%, transparent 40%, transparent),
                radial-gradient(circle at 0 150%, #030303 24%, #0a0a0a 24%, #0a0a0a 28%, #030303 28%, #030303 36%, #0a0a0a 36%, #0a0a0a 40%, transparent 40%, transparent),
                radial-gradient(circle at 50% 100%, #0a0a0a 10%, #030303 10%, #030303 23%, #0a0a0a 23%, #0a0a0a 30%, #030303 30%, #030303 43%, #0a0a0a 43%, #0a0a0a 50%, #030303 50%, #030303 63%, #0a0a0a 63%, #0a0a0a 71%, transparent 71%, transparent),
                radial-gradient(circle at 100% 50%, #0a0a0a 5%, #030303 5%, #030303 15%, #0a0a0a 15%, #0a0a0a 20%, #030303 20%, #030303 29%, #0a0a0a 29%, #0a0a0a 34%, #030303 34%, #030303 44%, #0a0a0a 44%, #0a0a0a 49%, transparent 49%, transparent),
                radial-gradient(circle at 0 50%, #0a0a0a 5%, #030303 5%, #030303 15%, #0a0a0a 15%, #0a0a0a 20%, #030303 20%, #030303 29%, #0a0a0a 29%, #0a0a0a 34%, #030303 34%, #030303 44%, #0a0a0a 44%, #0a0a0a 49%, transparent 49%, transparent);
            background-size: 20px 20px;
        }

        .carbon-console, .carbon-panel {
            position: relative;
            border-radius: 0.5rem; /* Angepasst an original rounded-lg / rounded-md */
            border: 1px solid #1a1a1a;
            background-color: #030303;
            box-shadow: 0 10px 30px -10px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.03);
        }
        
        .carbon-console { border-top: 1px solid #444; }

        .carbon-console::after, .carbon-panel::after {
            content: ''; position: absolute; inset: 0; background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.6)); border-radius: inherit; pointer-events: none;
        }

        .carbon-content { position: relative; z-index: 10; }

        html:not(.dark) .bg-deep-space { background-color: #F4F2EF; }
        html:not(.dark) .carbon-weave-bg {
            background-image: none;
            background-color: #FAF9F7;
        }
        html:not(.dark) .carbon-console,
        html:not(.dark) .carbon-panel {
            border: 1px solid #D6D3D1;
            box-shadow: 0 8px 20px -10px rgba(28, 25, 23, 0.15);
            background-color: #FFFFFF;
        }
        html:not(.dark) .carbon-console::after,
        html:not(.dark) .carbon-panel::after {
            background: none;
        }
        html:not(.dark) .metal-badge {
            background: linear-gradient(to bottom, #FAF9F7, #EDEAE6);
            border: 1px solid #D6D3D1;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.8), 0 2px 6px rgba(28,25,23,0.06);
        }

        /* NEON LED COLORS */
        .led-purple  { color: #c084fc; text-shadow: 0 0 10px rgba(192,132,252,0.6), 0 0 20px rgba(192,132,252,0.3); }
        .led-emerald { color: #10b981; text-shadow: 0 0 10px rgba(16,185,129,0.6), 0 0 20px rgba(16,185,129,0.3); }
        .led-lime    { color: #a3e635; text-shadow: 0 0 10px rgba(163,230,53,0.6),  0 0 20px rgba(163,230,53,0.3); }
        .led-amber   { color: #fbbf24; text-shadow: 0 0 10px rgba(251,191,36,0.6),  0 0 20px rgba(251,191,36,0.3); }
        .led-orange  { color: #fb923c; text-shadow: 0 0 10px rgba(251,146,60,0.6),  0 0 20px rgba(251,146,60,0.3); }
        .led-red     { color: #ef4444; text-shadow: 0 0 10px rgba(239,68,68,0.6),   0 0 20px rgba(239,68,68,0.3); }
        .led-gold    { color: #E6C299; text-shadow: 0 0 10px rgba(230,194,153,0.6), 0 0 20px rgba(230,194,153,0.3); }
        .led-white   { color: #fff; text-shadow: 0 0 15px rgba(255,255,255,0.5); }

        /* LIGHT-MODE: LED-Farben abgedunkelt, ohne Glow (Dark bleibt unangetastet) */
        html:not(.dark) .led-purple  { color: #6D28D9; text-shadow: none; }
        html:not(.dark) .led-emerald { color: #047857; text-shadow: none; }
        html:not(.dark) .led-lime    { color: #4D7C0F; text-shadow: none; }
        html:not(.dark) .led-amber   { color: #B45309; text-shadow: none; }
        html:not(.dark) .led-orange  { color: #C2410C; text-shadow: none; }
        html:not(.dark) .led-red     { color: #B91C1C; text-shadow: none; }
        html:not(.dark) .led-gold    { color: var(--pe-accent-text); text-shadow: none; }
        html:not(.dark) .led-white   { color: #1C1917; text-shadow: none; }

        .metal-badge {
            background: linear-gradient(to bottom, #222, #0a0a0a);
            border: 1px solid #333;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.1), 0 4px 10px rgba(0,0,0,0.8);
            border-radius: 4px;
        }

        /* Feste Seiten-Scrollbar am Viewport — nicht erst am Dokumentende */
        #main-scroll-container {
            scrollbar-width: thin;
            scrollbar-color: #E6C299 #0a0a0a;
        }
        #main-scroll-container::-webkit-scrollbar {
            height: 14px;
            width: 14px;
        }
        #main-scroll-container::-webkit-scrollbar-track {
            background: #0a0a0a;
        }
        #main-scroll-container::-webkit-scrollbar-thumb {
            background: #E6C299;
            border-radius: 4px;
            border: 2px solid #0a0a0a;
        }
        #main-scroll-container::-webkit-scrollbar-thumb:hover {
            background: #f0d4b0;
        }
        html:not(.dark) #main-scroll-container {
            scrollbar-color: #8D6435 #EAE7E2;
        }
        html:not(.dark) #main-scroll-container::-webkit-scrollbar-track {
            background: #EAE7E2;
        }
        html:not(.dark) #main-scroll-container::-webkit-scrollbar-thumb {
            background: #8D6435;
            border-color: #EAE7E2;
        }
        html:not(.dark) #main-scroll-container::-webkit-scrollbar-thumb:hover {
            background: #6d4c28;
        }
        `}</style>
);

// ============================================================================
// KONSTANTEN & HILFSFUNKTIONEN (PANZERUNG)
// ============================================================================
const COUNT_HJ = 6;

const ensureArr = (val: any, fallback: any[] = []) => {
    if (Array.isArray(val)) return val.length > 0 ? val : fallback;
    if (typeof val === 'object' && val !== null) {
        const arr = Object.values(val);
        return arr.length > 0 ? arr : fallback;
    }
    return fallback;
};

const safeDiv = (numerator: number, denominator: number): number => {
    const num = Number(numerator);
    const den = Number(denominator);
    if (!den || isNaN(num) || isNaN(den)) return 0;
    return num / den;
};

const formatCurrency = (value: number, currencyCode: string, decimalPlaces = 0): string => {
    const numStr = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(value || 0);
    return `${numStr} ${currencyCode}`;
};

const getVkFaktorColor = (wertProzent: number): string => {
    // Keine Einträge / 0% = neutral, nicht „negativ rot“
    if (isNaN(wertProzent) || wertProzent <= 0) return 'text-slate-500';
    if (wertProzent >= 15) return 'text-purple-400 led-purple';
    if (wertProzent >= 10) return 'text-emerald-400 led-emerald';
    if (wertProzent >= 6.9) return 'text-lime-400 led-lime';
    if (wertProzent >= 5) return 'text-amber-400 led-amber';
    if (wertProzent >= 3) return 'text-orange-400 led-orange';
    return 'text-red-400 led-red';
};

const getUmsatzAuslastungStyles = (val: number) => {
    const p = val <= 5 ? val * 100 : val;
    
    if (isNaN(p) || p === 0) return { text: 'text-slate-500', border: 'border-slate-700' };
    if (p >= 85) return { text: 'text-purple-400 shadow-[0_0_10px_rgba(168,85,247,0.5)]', border: 'border-purple-500' };
    if (p >= 75) return { text: 'text-emerald-400', border: 'border-emerald-500' };
    if (p >= 70) return { text: 'text-lime-400', border: 'border-lime-500' };
    if (p >= 60) return { text: 'text-amber-400', border: 'border-amber-500' };
    if (p >= 50) return { text: 'text-orange-400', border: 'border-orange-500' };
    return { text: 'text-red-400', border: 'border-red-500' };
};

const getMitarbeiterStatus = (umsatz: number, soll: number, kostendeckung: number): MitarbeiterStatus => {
    if (umsatz <= 0) return 'neutral';
    if (umsatz >= soll) return 'ok';
    if (umsatz >= kostendeckung) return 'warnung';
    return 'schlecht';
};

const buildMonatsFestsetzungSnapshot = (metrics: any, faktoren: any) => ({
    arbeitstage: Number(metrics?.arbeitstage) || 0,
    wochenstunden: Number(metrics?.wochenstunden) || 0,
    lohnfaktor: safeDiv(metrics?.sollUmsatzMonat, metrics?.effektiverBruttolohn),
    sollUmsatzMonat: Number(metrics?.sollUmsatzMonat) || 0,
    effektiverBruttolohn: Number(metrics?.effektiverBruttolohn) || 0,
    stdLohnGrund: Number(metrics?.stdLohnGrund) || 0,
    stdLohnEffektiv: Number(metrics?.stdLohnEffektiv) || 0,
    stdLohnGesamt: Number(metrics?.stdLohnGesamt) || 0,
    basisMetrics: JSON.parse(JSON.stringify(metrics || {})),
    bonusFaktoren: { ...(faktoren || {}) },
});

/** Snapshot für einen beliebigen MA aus dem aktuellen Store (Bulk-Festmachen). */
const buildSnapshotForEmployeeId = (
    targetEmployeeId: string,
    halbjahrKey: 'halbjahr1' | 'halbjahr2',
    sharedCalc: {
        mwstFaktor: number;
        lohnfaktorAktiv: number;
        geraeteListe: any;
        baseMaterialProzent: number;
        gemeinkostenPercent: number;
        avgSozialabgabenPercent: number;
        lohnfortzahlungPercent: number;
        verlustPercent: number;
        storeSettings: any;
    }
) => {
    const state = useAppStore.getState() as any;
    const pData = ensureArr(state.clientData?.personalData);
    const employee = pData.find((p: any) => p && String(p.id) === String(targetEmployeeId));
    if (!employee) return null;
    const leistung = state.clientData?.mitarbeiterLeistung?.[targetEmployeeId] || {};
    const result = computeEmployeeLeistung({
        employee,
        leistung,
        lohnfaktorData: state.clientData?.lohnfaktorData || {},
        globalSettings: state.settings?.global || {},
        countrySettings: state.settings?.country || {},
        leistungsprovision: state.clientData?.leistungsprovision || {},
        kalkulatorState: state.clientData?.kalkulator || {},
        isHJ1GesperrtGlobal: Boolean(state.clientData?.isHJ1GesperrtGlobal),
        isHJ2Freigegeben: Boolean(state.clientData?.isHJ2Freigegeben),
        isTeamBonusMode: state.clientData?.teamBonus?.bonusMode === 'team',
        mwstFaktor: sharedCalc.mwstFaktor,
        lohnfaktorAktiv: sharedCalc.lohnfaktorAktiv,
        geraeteListe: sharedCalc.geraeteListe,
        baseMaterialProzent: sharedCalc.baseMaterialProzent,
        gemeinkostenPercent: sharedCalc.gemeinkostenPercent,
        avgSozialabgabenPercent: sharedCalc.avgSozialabgabenPercent,
        lohnfortzahlungPercent: sharedCalc.lohnfortzahlungPercent,
        verlustPercent: sharedCalc.verlustPercent,
        storeSettings: sharedCalc.storeSettings,
    });
    if (!result) return null;
    const metrics = halbjahrKey === 'halbjahr1' ? result.metricsHJ1 : result.metricsHJ2;
    const faktoren = halbjahrKey === 'halbjahr1' ? result.faktorenHJ1 : result.faktorenHJ2;
    return buildMonatsFestsetzungSnapshot(metrics, faktoren);
};

const FestmachenBulkModal = ({
    isOpen,
    monthLabel,
    isLocking,
    staff,
    selectedIds,
    onToggle,
    onSelectAll,
    onSelectNone,
    onConfirm,
    onCancel,
    isBusy,
}: {
    isOpen: boolean;
    monthLabel: string;
    isLocking: boolean;
    staff: { id: string; name: string }[];
    selectedIds: string[];
    onToggle: (id: string) => void;
    onSelectAll: () => void;
    onSelectNone: () => void;
    onConfirm: () => void;
    onCancel: () => void;
    isBusy: boolean;
}) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-[#15171e] border border-[#E6C299]/40 rounded-2xl p-6 max-w-lg w-full shadow-2xl max-h-[85vh] flex flex-col">
                <h3 className="text-lg font-black text-white uppercase tracking-widest mb-1">
                    {isLocking ? 'Monat festmachen' : 'Festsetzung aufheben'}
                </h3>
                <p className="text-sm text-slate-400 mb-4">
                    {monthLabel} — wähle die Mitarbeiter, für die das gelten soll.
                </p>
                <div className="flex gap-2 mb-3">
                    <button type="button" onClick={onSelectAll} className="px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest rounded-lg bg-[#E6C299]/15 text-[#E6C299] border border-[#E6C299]/40 hover:bg-[#E6C299]/25">
                        Alle
                    </button>
                    <button type="button" onClick={onSelectNone} className="px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest rounded-lg bg-slate-800 text-slate-300 border border-slate-600 hover:bg-slate-700">
                        Keine
                    </button>
                    <span className="ml-auto text-xs text-slate-500 self-center">{selectedIds.length} / {staff.length}</span>
                </div>
                <div className="flex-1 overflow-y-auto space-y-1 mb-4 pr-1 custom-scrollbar border border-slate-800 rounded-xl p-2 bg-black/40">
                    {staff.map((ma) => {
                        const checked = selectedIds.includes(ma.id);
                        return (
                            <label
                                key={ma.id}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer transition-colors ${checked ? 'bg-[#E6C299]/10 border border-[#E6C299]/30' : 'hover:bg-white/5 border border-transparent'}`}
                            >
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={() => onToggle(ma.id)}
                                    className="form-checkbox h-4 w-4 rounded text-[#E6C299] bg-black border-slate-600"
                                />
                                <span className="text-sm text-slate-200 font-medium truncate">{ma.name || 'Ohne Name'}</span>
                            </label>
                        );
                    })}
                </div>
                <div className="flex gap-3">
                    <button type="button" onClick={onCancel} disabled={isBusy} className="flex-1 py-3 rounded-xl bg-slate-800 text-white font-bold uppercase text-xs tracking-widest border border-slate-700 disabled:opacity-50">
                        Abbrechen
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isBusy || selectedIds.length === 0}
                        className="flex-1 py-3 rounded-xl bg-[#E6C299] text-black font-black uppercase text-xs tracking-widest disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        {isBusy ? 'Speichert…' : isLocking ? `Festmachen (${selectedIds.length})` : `Aufheben (${selectedIds.length})`}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// BERECHNUNGSLOGIK-HOOK
// ============================================================================
const useLeistungCalculations = (employeeId: string, mwstFaktor: number) => {
    const { 
        lohnfaktorAktiv, 
        geraeteListe,
        baseMaterialProzent,
        gemeinkostenPercent,
        avgSozialabgabenPercent,
        lohnfortzahlungPercent,
        verlustPercent,
        settings: storeSettings
    } = useCalculationsSelector();

    const { employee, leistung, lohnfaktorData, globalSettings, countrySettings, leistungsprovision, kalkulatorState, isHJ1GesperrtGlobal, isHJ2Freigegeben, isTeamBonusMode } = useAppStore(state => {
        const pData = ensureArr(state.clientData?.personalData);
        const foundEmployee = pData.find((p: any) => p && p.id === employeeId);
        
        return {
            employee: foundEmployee,
            leistung: state.clientData?.mitarbeiterLeistung?.[employeeId] || {},
            lohnfaktorData: state.clientData?.lohnfaktorData || {},
            globalSettings: state.settings?.global || {},
            countrySettings: state.settings?.country || {},
            leistungsprovision: (state.clientData as any)?.leistungsprovision || {},
            kalkulatorState: state.clientData?.kalkulator || {},
            isHJ1GesperrtGlobal: Boolean(state.clientData?.isHJ1GesperrtGlobal),
            isHJ2Freigegeben: Boolean(state.clientData?.isHJ2Freigegeben),
            isTeamBonusMode: state.clientData?.teamBonus?.bonusMode === 'team',
        };
    });

    return useMemo(() => {
        return computeEmployeeLeistung({
            employee,
            leistung,
            lohnfaktorData,
            globalSettings,
            countrySettings,
            leistungsprovision,
            kalkulatorState,
            isHJ1GesperrtGlobal,
            isHJ2Freigegeben,
            isTeamBonusMode,
            mwstFaktor,
            lohnfaktorAktiv,
            geraeteListe,
            baseMaterialProzent,
            gemeinkostenPercent,
            avgSozialabgabenPercent,
            lohnfortzahlungPercent,
            verlustPercent,
            storeSettings,
        });
    }, [employee, leistung, lohnfaktorData, globalSettings, countrySettings, leistungsprovision, mwstFaktor, lohnfaktorAktiv, geraeteListe, baseMaterialProzent, gemeinkostenPercent, avgSozialabgabenPercent, lohnfortzahlungPercent, verlustPercent, storeSettings, kalkulatorState, isHJ1GesperrtGlobal, isHJ2Freigegeben, isTeamBonusMode]);
};

// ============================================================================
// UI COMPONENTS
// ============================================================================

const FormulaDisplay = ({ value, type, isPercentage = false, isFactor = false, decimalPlaces = 0, suffix = '', highlightNegative = false, className = '', bgColor = 'bg-pe-input', textColor = 'text-pe-accent-text', showFormulas, formula, currencyCode }: any) => {
    if (showFormulas && formula) return <div className={`w-full p-1 rounded-md text-center font-bold font-mono-numbers flex items-center justify-center h-full text-purple-700 dark:text-purple-400 text-xs ${bgColor} border border-pe-border-strong`}>{formula}</div>;
     
    let displayValue: string | number = '-';
    const isText = type === 'text' || (typeof value === 'string' && type !== 'currency' && type !== 'number' && !isPercentage && !isFactor);
    if (typeof value === 'number' && !isNaN(value)) {
        if (isPercentage) displayValue = `${value.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
        else if (isFactor) displayValue = value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        else if (type === 'currency') displayValue = formatCurrency(value, currencyCode || 'EUR', decimalPlaces);
        else displayValue = `${value.toLocaleString('de-DE', { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })}${suffix ? ` ${suffix}` : ''}`;
    } else if (isText) displayValue = value ?? '-';

    const wrapClass = isText ? 'whitespace-normal break-words leading-snug text-[11px] sm:text-xs px-0.5' : 'whitespace-nowrap';
    let finalClassName = `w-full p-1 rounded text-center font-bold font-mono-numbers flex items-center justify-center border border-pe-border-strong ${wrapClass} ${className} ${bgColor} ${textColor}`;
     
    if (highlightNegative && typeof value === 'number' && value < 0) { 
        finalClassName = `w-full p-1 rounded text-center font-bold font-mono-numbers flex items-center justify-center border border-red-800/50 whitespace-nowrap ${className} bg-red-900/30 text-red-400`; 
    }
     
    return <div className={finalClassName} title={isText && displayValue ? String(displayValue) : undefined}>{displayValue}</div>;
};

const formatSignedCurrency = (value: number, currencyCode: string, decimalPlaces = 0): string => {
    const abs = formatCurrency(Math.abs(value || 0), currencyCode, decimalPlaces);
    if (!value) return abs;
    return value > 0 ? `+${abs}` : `−${abs}`;
};

const UmsatzIndicatorWithText = ({ umsatz, soll, kostendeckung }: { umsatz: number, soll: number, kostendeckung: number }) => {
    if (umsatz <= 0) return <div className="h-full w-full"></div>;
    const status = getMitarbeiterStatus(umsatz, soll, kostendeckung);
    let icon, text, textColor, tooltipText;
    if (status === 'ok') { icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.993 0-1.854-.656-2.148-1.595l-2-6A2 2 0 018.25 10V5a2 2 0 012-2h2.5a2 2 0 012 2v5z" /></svg>; text = 'Ziel übertroffen'; textColor = 'text-emerald-500'; tooltipText = "Hervorragend! Der Mitarbeiter hat seinen Soll-Umsatz erreicht oder übertroffen."; } 
    else if (status === 'warnung') { icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>; text = 'Über Kostendeckung'; textColor = 'text-amber-500'; tooltipText = "Gut! Der Mitarbeiter deckt seine Kosten, hat das Soll aber noch nicht erreicht."; } 
    else { icon = <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.738 3h4.017c.993 0 .1854-.656-2.148-1.595l2 6A2 2 0 0116.75 14v5a2 2 0 01-2-2h-2.5a2 2 0 01-2-2v-5z" /></svg>; text = 'Unter Kostendeckung'; textColor = 'text-red-500'; tooltipText = "Achtung! Der Mitarbeiter erwirtschaftet nicht genügend Umsatz, um seine Kosten zu decken."; }
    return <div className={`flex flex-col items-center justify-center space-y-1 p-1 h-full cursor-help`} data-tooltip-id="app-tooltip" data-tooltip-content={tooltipText}><div className={`flex-shrink-0 ${textColor}`}>{icon}</div><div className={`text-[10px] font-bold text-center leading-tight ${textColor}`}>{text}</div></div>;
};

const PerformanceHinweis = ({ metrics, durchschnitt, currencyCode }: { metrics: any, durchschnitt: any, currencyCode: string }) => {
    const umsatz = durchschnitt.gesamtUmsatzBrutto;
    if (umsatz <= 0) return null;
    const soll = durchschnitt.sollUmsatzMonat || metrics.sollUmsatzMonat || 0;
    const kostendeckung = durchschnitt.kostendeckungsumsatz || metrics.kostendeckungsumsatz || 0;
    const delta = Number(durchschnitt.deltaNetto) || 0;
    const label = delta >= 0 ? 'Überschuss' : 'Defizit';

    let boxClasses = "bg-red-100/80 dark:bg-red-900/20 border-red-300 dark:border-red-500/50 text-red-950 dark:text-red-300";
    let title = "Dringender Handlungsbedarf";
    let text = "Achtung: Der Mitarbeiter ist nicht profitabel. Der Umsatz liegt unter dem Totpunkt (Break-Even). Bitte kontaktiere umgehend deinen Betreuer!";

    if (umsatz >= soll) {
        boxClasses = "bg-emerald-100/80 dark:bg-emerald-900/20 border-emerald-300 dark:border-emerald-500/50 text-emerald-950 dark:text-emerald-300";
        title = "Hervorragende Leistung!";
        text = "Der Mitarbeiter hat das Umsatzziel übertroffen und arbeitet sehr profitabel. Weiter so!";
    } else if (umsatz >= kostendeckung) {
        boxClasses = "bg-amber-100/80 dark:bg-amber-900/20 border-amber-300 dark:border-amber-500/50 text-amber-950 dark:text-amber-300";
        title = "Ziel knapp verfehlt, aber profitabel";
        text = "Der Mitarbeiter deckt seine Kosten, hat das Umsatzziel jedoch nicht ganz erreicht. Kontaktiere deinen Berater, um das Potenzial voll auszuschöpfen.";
    } else if (umsatz >= (metrics.totpunktMonatsumsatz || 0)) {
        boxClasses = "bg-orange-100/80 dark:bg-orange-900/20 border-orange-300 dark:border-orange-500/50 text-orange-950 dark:text-orange-300";
        title = "Leistungshinweis";
        text = "Der durchschnittliche Monatsumsatz des Mitarbeiters liegt unter dem Kostendeckungsumsatz. Bitte kontaktiere deinen Betreuer.";
    }

    return (
        <div className={`max-w-lg p-3 rounded-lg border text-left ${boxClasses}`}>
            <div className="flex items-start gap-4">
                <div className="shrink-0">
                    <UmsatzIndicatorWithText umsatz={umsatz} soll={soll} kostendeckung={kostendeckung} />
                </div>
                <div className="min-w-0">
                    <h4 className="font-bold text-sm">{title}</h4>
                    <p className="text-xs mt-1">{text}</p>
                    <div className="mt-2">
                        <div className="text-[10px] font-bold uppercase tracking-widest opacity-70">{label} Ø</div>
                        <div className={`text-lg font-black font-mono-numbers leading-tight ${delta >= 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`}>
                            {formatSignedCurrency(delta, currencyCode || 'EUR')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PerformanceFeedback = ({ istUmsatz, sollUmsatz, currencyCode }: { istUmsatz: number, sollUmsatz: number, currencyCode: string }) => {
    const diff = istUmsatz - sollUmsatz;
    if (diff >= 0 || istUmsatz <= 0) return <div className="p-3 bg-pe-card dark:bg-[#111] rounded-md border border-pe-border-strong h-full flex items-center justify-center text-emerald-700 dark:text-emerald-400 font-bold">Ziel erreicht!</div>
    const zusatzumsatzWert = 30;
    const stundenProVerkauf = safeDiv(zusatzumsatzWert, Math.abs(diff));
    return (
        <div className="p-2 bg-pe-card dark:bg-[#111] rounded-md border border-pe-border-strong h-full flex flex-col justify-center text-center cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Dieser Tipp zeigt, wie oft ein kleiner Zusatzumsatz (hier beispielhaft 30 €) erzielt werden muss, um die Lücke zwischen dem IST- und dem SOLL-Stundenumsatz zu schließen. Es dient als praktische Hilfestellung für den Mitarbeiter.">
            <div className="flex items-baseline justify-center mb-1">
                <div className="text-red-600 dark:text-red-400 font-bold font-mono-numbers text-lg mr-2">{formatCurrency(diff, currencyCode, 2)}</div>
                <div className="text-xs text-pe-muted dark:text-slate-400">pro Stunde</div>
            </div>
            {stundenProVerkauf > 0 && (
                <div className="text-xs text-pe-muted dark:text-slate-300 leading-tight p-2 bg-pe-tile-header rounded-lg border border-pe-border dark:border-[#222] text-left">
                    <h5 className="font-semibold mb-1 text-slate-400 text-center">Tipp zum Ausgleich:</h5>
                    <p className="text-center">Alle <span className="font-bold text-pe-text mx-1">{stundenProVerkauf.toFixed(1).replace('.',',')} Std.</span> einen Zusatzumsatz von <span className="font-bold text-pe-text mx-1">{formatCurrency(zusatzumsatzWert, currencyCode)}</span> erzielen.</p>
                </div>
            )}
        </div>
    );
};

const CurrencyInput = (props: any) => <EditableField className="h-8 text-sm p-1 w-24 bg-pe-input text-stone-900 dark:text-white font-mono-numbers outline-none border border-stone-300 dark:border-white/10 focus:border-[#E6C299]" type="currency" decimalPlaces={0} readOnly={false} onFocus={(e: any) => e.target.select()} {...props} />;
const NumberInput = (props: any) => <EditableField className="h-8 text-sm p-1 w-24 bg-pe-input text-stone-900 dark:text-white font-mono-numbers outline-none border border-stone-300 dark:border-white/10 focus:border-[#E6C299]" type="number" readOnly={false} onFocus={(e: any) => e.target.select()} {...props} />;

const CompactTile = ({ label, value, formula, type = 'text', width = 'w-32', textColor, bgColor = 'bg-pe-card', isFactor=false, suffix='', tooltip, children, currencyCode, decimalPlaces, highlightNegative = false }: any) => {
    const valueColor = textColor ?? ((type === 'currency' || isFactor) ? 'text-pe-accent-text' : 'text-stone-900 dark:text-white');
    const isTextTile = type === 'text';
    return (
    <div className={`flex flex-col ${width} ${bgColor} border border-stone-200 dark:border-pe-border-strong rounded overflow-hidden ${tooltip ? 'cursor-help' : ''}`} data-tooltip-id={tooltip ? "app-tooltip" : undefined} data-tooltip-content={tooltip}>
       <div className="text-[10px] font-semibold text-pe-muted uppercase tracking-wide bg-stone-100 dark:bg-pe-tile-header px-1 py-1 text-center border-b border-stone-200 dark:border-[#222] leading-tight min-h-[2.5rem] flex items-center justify-center whitespace-normal">{label}</div>
       <div className={`flex-grow flex items-center justify-center p-1 min-w-0 ${isTextTile ? 'min-h-[2.25rem]' : ''}`}>
           {children ? children : (
                <FormulaDisplay 
                    value={value} 
                    formula={formula} 
                    type={type} 
                    isFactor={isFactor}
                    suffix={suffix}
                    highlightNegative={highlightNegative}
                    className={`${isTextTile ? 'text-xs' : 'text-sm'} font-mono-numbers font-bold bg-transparent border-none h-auto p-0 pointer-events-none min-w-0`} 
                    textColor={valueColor} 
                    currencyCode={currencyCode}
                    decimalPlaces={decimalPlaces !== undefined ? decimalPlaces : (type === 'currency' ? 0 : (isFactor ? 2 : 1))}
                />
            )}
       </div>
   </div>
    );
};

// --- STAMMDATEN MIT INTEGRIERTER GERÄTE-AUSWAHL ---
const StammdatenCompactSektion = ({ title, metrics, employee, showFormulas, currencyCode, leistung, employeeId, isCollapsed = false, onToggleCollapse, isGodMode = false, isStammdatenLocked = false }: any) => {
    const arbeitszeitTag = useMemo(() => safeDiv(employee.wochenstunden, employee.arbeitstage), [employee]);
    const angezeigterFaktor = safeDiv(metrics.sollUmsatzMonat, metrics.effektiverBruttolohn);
    
    const updateMitarbeiterLeistung = useAppStore(state => state.updateMitarbeiterLeistung);
    const captureState = useAppStore(state => state.captureState); 

    const [actionToConfirm, setActionToConfirm] = useState<(() => void) | null>(null);
    const [isPasswordOpen, setIsPasswordOpen] = useState(false);

    const { geraeteListe } = useCalculationsSelector();
    const safeGeraete = ensureArr(geraeteListe);

    if (!metrics || !employee) return null;

    const showGerateSelection = employee.arbeitetMitGeraeten && safeGeraete.length > 0;
    const activeDeviceIds = Array.isArray(employee._frozenDeviceIds)
        ? employee._frozenDeviceIds
        : ensureArr(leistung.selectedDeviceIds);

    const handleDeviceToggle = (deviceId: string) => {
        if (isStammdatenLocked) return;
        setActionToConfirm(() => () => {
            const currentSelection = ensureArr(leistung.selectedDeviceIds);
            let newSelection;
            if (currentSelection.includes(deviceId)) {
                newSelection = currentSelection.filter((id: string) => id !== deviceId);
            } else {
                newSelection = [...currentSelection, deviceId];
            }
            captureState();
            updateMitarbeiterLeistung(employeeId, { selectedDeviceIds: newSelection });
        });
        setIsPasswordOpen(true);
    };

    const confirmPassword = (pw: string) => {
        if (pw === '90') {
            if (actionToConfirm) actionToConfirm();
        } else {
            alert('Falsches Passwort');
        }
        setIsPasswordOpen(false);
    };

    return (
        <div className="mb-6 p-4 carbon-panel border border-pe-border-strong rounded-lg w-fit bg-pe-card dark:bg-[#030303]">
            <PasswordPrompt isOpen={isPasswordOpen} onClose={() => setIsPasswordOpen(false)} onConfirm={confirmPassword} title="Geräte-Auswahl ändern?" />
            <h4 className="text-md font-bold text-pe-text mb-4 border-b border-pe-border-strong pb-2 px-3 py-2 carbon-weave-bg rounded-lg carbon-content flex items-center justify-between gap-3">
                <span>{title}</span>
                {isGodMode && (
                    <button type="button" onClick={onToggleCollapse} className="text-slate-400 hover:text-pe-accent-text text-sm font-bold px-1" title={isCollapsed ? 'Aufklappen' : 'Zuklappen'}>
                        {isCollapsed ? '▸' : '▾'}
                    </button>
                )}
            </h4>
            {!isCollapsed && (
            <>
            <div className="flex flex-wrap gap-2 mb-4 carbon-content">
                <CompactTile label="Mitarbeiter" value={employee.name} width="w-48" tooltip="Name des Mitarbeiters." />
                <CompactTile label="Tätigkeit" value={employee.taetigkeit} width="w-36" tooltip="Ausgeübte Tätigkeit im Salon." />
                <CompactTile label={<>Zugehörig-<br/>keit</>} value={employee.zugehoerigkeit} width="w-48" tooltip="Betriebszugehörigkeit (z.B. Probezeit)." />
                <div className="w-4"></div>
                <CompactTile label={<>Arbeit-<br/>stage</>} value={metrics.arbeitstage} suffix=" Tage" width="w-24" type="number" tooltip="Reguläre Arbeitstage pro Woche." />
                <CompactTile label={<>Wochen-<br/>std.</>} value={metrics.wochenstunden} suffix=" Std" width="w-24" type="number" tooltip="Vertragliche Wochenstunden am Kunden." />
                <CompactTile label={<>Monats-<br/>std.</>} value={metrics.monatsStunden} suffix=" Std" width="w-24" type="number" tooltip="Monatliche Arbeitsstunden (Wochenstd. x Faktor)." />
                <CompactTile label={<>Ø Std/<br/>Tag</>} value={arbeitszeitTag} suffix=" Std" width="w-24" type="number" tooltip="Durchschnittliche Arbeitszeit pro regulärem Arbeitstag." />
            </div>
            <div className="flex flex-wrap gap-2 carbon-content">
                <CompactTile label={<>Lohnfaktor<br/>Soll</>} value={angezeigterFaktor} isFactor={true} width="w-32" textColor="text-amber-700 dark:text-amber-400" className="font-extrabold text-lg" tooltip="Der angestrebte Faktor zur Berechnung des Soll-Umsatzes." />
                <CompactTile label={<>Soll /<br/>Monat</>} value={metrics.sollUmsatzMonat} type="currency" width="w-32" textColor="text-amber-700 dark:text-amber-400" tooltip="Der errechnete Zielumsatz für diesen Mitarbeiter pro Monat." currencyCode={currencyCode} />
                <div className="w-4 border-l border-pe-border-strong mx-1"></div>
                <CompactTile label={<>Grund-<br/>gehalt</>} value={metrics.grundgehalt} type="currency" decimalPlaces={2} width="w-28" tooltip="Monatliches vertragliches Grundgehalt." currencyCode={currencyCode} />
                <CompactTile label={<>Lohnkosten-<br/>zusatz</>} value={metrics.lohnkostenzusatz || metrics.lohnzusatz} type="currency" decimalPlaces={2} width="w-28" tooltip="Monatliche Lohnkostenzusätze (Fahrtkosten, Sachbezug etc.)." currencyCode={currencyCode} />
                <CompactTile label={<>Effektiv<br/>Brutto</>} value={metrics.effektiverBruttolohn} type="currency" decimalPlaces={2} width="w-32" textColor="text-pe-accent-text" tooltip="Die Summe aus Grundgehalt und Lohnkostenzusatz." currencyCode={currencyCode} />
                <CompactTile label={<>Bonus<br/>(Input)</>} value={metrics.bonus} type="currency" decimalPlaces={0} width="w-24" tooltip="Manuell eingegebener Bonus aus der Simulation." currencyCode={currencyCode} />
                <CompactTile label={<>Gesamt-<br/>lohn</>} value={metrics.gesamtlohnBrutto} type="currency" decimalPlaces={2} width="w-32" textColor="text-pe-accent-text" tooltip="Das Gesamtbrutto (Effektiv Brutto + Bonus)." currencyCode={currencyCode} />
                <div className="w-4 border-l border-pe-border-strong mx-1"></div>
                
                <CompactTile label={<>Std.Lohn<br/>Grund</>} value={metrics.stdLohnGrund} type="currency" decimalPlaces={2} width="w-28" tooltip="Stundenlohn nur auf Basis des Grundgehalts." currencyCode={currencyCode} />
                <CompactTile label={<>Std.Lohn<br/>Effektiv</>} value={metrics.stdLohnEffektiv} type="currency" decimalPlaces={2} width="w-28" tooltip="Stundenlohn auf Basis des Effektiv-Bruttos." currencyCode={currencyCode} />
                <CompactTile label={<>Std.Lohn<br/>Gesamt</>} value={metrics.stdLohnGesamt} type="currency" decimalPlaces={2} width="w-28" textColor="text-pe-accent-text" tooltip="Stundenlohn auf Basis des Gesamtlohns inkl. Bonus." currencyCode={currencyCode} />
            </div>

            {showGerateSelection && (
                <div className="mt-4 pt-4 border-t border-pe-border-strong carbon-content">
                    <h5 className="text-xs font-bold text-pe-accent-text uppercase tracking-wider mb-2">Aktive Geräte (Auswahl)</h5>
                    <div className="flex flex-wrap gap-2">
                        {safeGeraete.filter(Boolean).map((geraet: any) => {
                            const isSelected = activeDeviceIds.includes(geraet.id);
                            return (
                                <button 
                                    key={geraet.id}
                                    onClick={() => handleDeviceToggle(geraet.id)}
                                    disabled={isStammdatenLocked}
                                    className={`px-3 py-1.5 rounded border text-xs font-bold transition-all flex items-center gap-2 ${isStammdatenLocked ? 'opacity-60 cursor-not-allowed' : ''} ${isSelected ? 'bg-blue-600 border-blue-400 text-white' : 'bg-pe-card dark:bg-black border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-400 hover:border-gray-400'}`}
                                >
                                    <div className={`w-3 h-3 rounded-sm border ${isSelected ? 'bg-white border-white' : 'border-gray-500'}`}>
                                        {isSelected && <svg className="w-full h-full text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4"><polyline points="20 6 9 17 4 12"/></svg>}
                                    </div>
                                    {geraet.name} <span className="opacity-70 font-mono-numbers">{(geraet.kostenProzent || 0).toFixed(1)}%</span>
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
            </>
            )}
        </div>
    );
};

const SollvorgabenCompactSektion = ({ title, metrics, tatsaechlicherGewinn, currencyCode, isCollapsed = false, onToggleCollapse, isGodMode = false }: any) => {
    if(!metrics) return null;
    const diffTo75 = metrics.salonStundensatz - metrics.requiredRate75;
    return (
        <div className="h-full flex flex-col p-4 carbon-panel border border-pe-border-strong rounded-lg w-fit bg-pe-card dark:bg-[#030303]">
            <h4 className="text-md font-bold text-pe-text mb-4 border-b border-pe-border-strong pb-2 px-3 py-2 carbon-weave-bg rounded-lg carbon-content flex items-center justify-between gap-3">
                <span>{title}</span>
                {isGodMode && (
                    <button type="button" onClick={onToggleCollapse} className="text-slate-400 hover:text-pe-accent-text text-sm font-bold px-1" title={isCollapsed ? 'Aufklappen' : 'Zuklappen'}>
                        {isCollapsed ? '▸' : '▾'}
                    </button>
                )}
            </h4>
            {!isCollapsed && (
            <div className="flex flex-wrap gap-2 content-start justify-start carbon-content">
                 <CompactTile label="Soll / Std" value={metrics.sollUmsatzProStunde} type="currency" width="w-28" textColor="text-orange-400" tooltip="Notwendiger Umsatz pro gearbeiteter Stunde." currencyCode={currencyCode} />
                 <CompactTile label={`Soll bei ${metrics.auslastungVorgabe}%`} value={metrics.requiredRate75} type="currency" width="w-28" tooltip={`Notwendiger Umsatz, wenn eine Auslastung von ${metrics.auslastungVorgabe}% angenommen wird.`} currencyCode={currencyCode} />
                 
                 <CompactTile label="Salon Ø/Std" width="w-32" tooltip="Stundensatz OHNE Material aus dem Kalkulator (Admin-Soll bzw. Mandanten-Override) und Differenz zum 75%-Soll.">
                     <div className="flex flex-col items-center justify-center w-full">
                         <div className="text-blue-300 font-bold font-mono-numbers text-[13px] leading-tight pb-0.5">{formatCurrency(metrics.salonStundensatz, currencyCode, 0)}</div>
                         <div className={`font-bold font-mono-numbers text-[11px] border-t border-pe-border-strong dark:border-[#444] pt-0.5 w-full text-center ${diffTo75 < 0 ? 'text-red-400' : 'text-emerald-400'}`}>
                             {diffTo75 > 0 ? '+' : ''}{formatCurrency(diffTo75, currencyCode, 0)} Diff.
                         </div>
                     </div>
                 </CompactTile>

                 <CompactTile label="Soll / Tag" value={metrics.sollUmsatzProTagBerechnet} type="currency" width="w-28" tooltip="Das tägliche Umsatzziel." currencyCode={currencyCode} />
                 <CompactTile label="Soll / Monat" value={metrics.sollUmsatzMonat} type="currency" width="w-28" textColor="text-amber-700 dark:text-amber-400" tooltip="Das monatliche Umsatzziel für diesen Mitarbeiter." currencyCode={currencyCode} />
                 <div className="w-full h-2"></div> 
                 <CompactTile label="Kostendeckung" value={metrics.kostendeckungsumsatz} type="currency" width="w-32" textColor="text-pe-accent-text" tooltip="Umsatz zur reinen Deckung der Lohnkosten." currencyCode={currencyCode} />
                 <CompactTile label="Faktor" value={metrics.kostendeckungsfaktor} isFactor={true} width="w-20" textColor="text-pe-accent-text" tooltip="Der hinterlegte Kostendeckungsfaktor." />
                 <CompactTile label="Prognose Gewinn" value={metrics.prognoseGewinnMonat} type="currency" width="w-32" highlightNegative={true} tooltip="Der erwartete Gewinn, wenn der Sollumsatz erreicht wird." currencyCode={currencyCode} />
                 <CompactTile label="Ø Gewinn (Ist)" value={tatsaechlicherGewinn} type="currency" width="w-32" highlightNegative={true} tooltip="Der reale, bisher erwirtschaftete Gewinn." currencyCode={currencyCode} />
            </div>
            )}
        </div>
    );
};

const BonusSimulationCompactSektion = ({ title, simulationData, setSimulationData, metricsJahr, currencyCode, isCollapsed = false, onToggleCollapse, isGodMode = false }: any) => {
    const handleUpdate = (field: string, value: number) => setSimulationData((prev: any) => ({ ...prev, [field]: value }));
    const sim = useMemo(() => {
        const calc: any = {};
        calc.zielGehalt = simulationData.zielStundenlohn * metricsJahr.monatsStunden;
        calc.neuesGehalt = metricsJahr.effektiverBruttolohn + simulationData.geplanterBonus;
        calc.differenz = calc.zielGehalt - metricsJahr.effektiverBruttolohn;
        calc.neuerStundenlohn = safeDiv(calc.neuesGehalt, metricsJahr.monatsStunden);
        calc.restbonus = simulationData.geplanterBonus - calc.differenz;
        return calc;
    }, [simulationData, metricsJahr]);

    return (
        <div className="h-full flex flex-col p-4 carbon-panel border border-pe-border-strong rounded-lg w-fit bg-pe-card dark:bg-[#030303]">
            <h4 className="text-md font-bold text-pe-text mb-4 border-b border-pe-border-strong pb-2 px-3 py-2 carbon-weave-bg rounded-lg carbon-content flex items-center justify-between gap-3">
                <span>{title}</span>
                {isGodMode && (
                    <button type="button" onClick={onToggleCollapse} className="text-slate-400 hover:text-pe-accent-text text-sm font-bold px-1" title={isCollapsed ? 'Aufklappen' : 'Zuklappen'}>
                        {isCollapsed ? '▸' : '▾'}
                    </button>
                )}
            </h4>
            {!isCollapsed && (
            <div className="grid grid-cols-4 gap-2 carbon-content">
                <CompactTile label="Grundgehalt inkl. LZK" value={metricsJahr.effektiverBruttolohn} type="currency" decimalPlaces={2} width="w-36" textColor="text-pe-accent-text" tooltip="Effektiv Brutto aus den Stammdaten." currencyCode={currencyCode} />
                <CompactTile label="geplanter Bonus" width="w-36" tooltip="Gib hier den Bonus ein, den der Mitarbeiter als Ziel erreichen soll.">
                     <EditableField value={simulationData.geplanterBonus} onChange={(v: number) => handleUpdate('geplanterBonus', v)} type="currency" decimalPlaces={0} className="h-full text-sm bg-pe-input text-stone-900 dark:text-white font-mono-numbers outline-none border border-stone-300 dark:border-white/10 focus:border-[#E6C299]" currencyCode={currencyCode} readOnly={false} onFocus={(e: any) => e.target.select()} />
                </CompactTile>
                <CompactTile label="neues Gehalt" value={sim.neuesGehalt} type="currency" decimalPlaces={2} width="w-36" textColor="text-emerald-400" tooltip="Ergebnis: Effektiv Brutto + der geplante Bonus." currencyCode={currencyCode} />
                <CompactTile label="neuer Stundenlohn" value={sim.neuerStundenlohn} type="currency" decimalPlaces={2} width="w-36" textColor="text-emerald-400" tooltip="Ergebnis: Neues Gehalt geteilt durch die Arbeitsstunden." currencyCode={currencyCode} />
                <CompactTile label="Ziel Stundenlohn" width="w-36" tooltip="Gib hier den Wunsch-Stundenlohn ein, den der Mitarbeiter erreichen möchte.">
                    <EditableField value={simulationData.zielStundenlohn} onChange={(v: number) => handleUpdate('zielStundenlohn', v)} type="currency" decimalPlaces={2} className="h-full text-sm bg-pe-input text-stone-900 dark:text-white font-mono-numbers outline-none border border-stone-300 dark:border-white/10 focus:border-[#E6C299]" currencyCode={currencyCode} readOnly={false} onFocus={(e: any) => e.target.select()} />
                </CompactTile>
                <CompactTile label="Ziel Gehalt" value={sim.zielGehalt} type="currency" decimalPlaces={2} width="w-36" textColor="text-pe-accent-text" tooltip="Das Gehalt, das für diesen Wunsch-Stundenlohn nötig wäre." currencyCode={currencyCode} />
                <CompactTile label="Differenz" value={sim.differenz} type="currency" decimalPlaces={0} width="w-36" textColor="text-pe-accent-text" tooltip="Differenz zwischen Ziel-Gehalt und dem aktuellen Effektiv-Brutto." currencyCode={currencyCode} />
                <CompactTile label="Restbonus" value={sim.restbonus} type="currency" decimalPlaces={0} width="w-36" textColor="text-emerald-400" tooltip="Bleibt nach Erreichen des Ziel-Gehalts noch vom geplanten Bonus übrig?" currencyCode={currencyCode} />
            </div>
            )}
        </div>
    );
};

const KostenstrukturAnalyseSektion = ({ title, metrics, currencyCode, isCollapsed = false, onToggleCollapse, isGodMode = false }: any) => {
    if(!metrics || !metrics.analyseKosten) return null;
    const renderRow = (label: string, prozent: number, wert: number) => (<div className="grid grid-cols-[140px_50px_80px] items-stretch border-b border-pe-border-strong hover:bg-pe-hover dark:hover:bg-[#1a1a1a] transition-colors"><div className="text-pe-muted dark:text-gray-300 text-[11px] font-semibold p-1 pl-2 flex items-center h-7 whitespace-nowrap overflow-hidden text-ellipsis" title={label}>{label}</div><div className="p-1 flex items-center justify-end"><FormulaDisplay value={prozent} isPercentage={true} className="text-xs h-6 p-0 bg-transparent border-none font-mono-numbers" currencyCode={currencyCode} /></div><div className="p-1 flex items-center justify-end"><FormulaDisplay value={wert} type="currency" className="text-xs h-6 p-0 bg-transparent border-none font-mono-numbers" currencyCode={currencyCode} /></div></div>);
     
    return (
        <div className="h-full flex flex-col p-4 carbon-panel border border-pe-border-strong rounded-lg w-fit bg-pe-card dark:bg-[#030303]">
             <h4 className="text-md font-bold text-pe-text mb-4 border-b border-pe-border-strong pb-2 px-3 py-2 carbon-weave-bg rounded-lg w-full carbon-content flex items-center justify-between gap-3">
                <span>{title}</span>
                {isGodMode && (
                    <button type="button" onClick={onToggleCollapse} className="text-slate-400 hover:text-pe-accent-text text-sm font-bold px-1" title={isCollapsed ? 'Aufklappen' : 'Zuklappen'}>
                        {isCollapsed ? '▸' : '▾'}
                    </button>
                )}
             </h4>
             <div className="w-[290px] border-2 border-pe-border-strong rounded-md flex-grow flex flex-col carbon-content">
                {/* Totpunkt bleibt IMMER sichtbar */}
                <div className="p-1 bg-pe-card dark:bg-[#111] cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="BREAK-EVEN-POINT: Wird dieser Umsatz unterschritten, rechnet sich der Mitarbeiter nicht mehr und kostet das Unternehmen aktiv Geld. Das ist der absolute Totpunkt!">
                    <div className="flex justify-between items-center border-2 border-red-500 rounded-lg p-1">
                        <span className="flex items-center text-xs font-bold text-red-400 uppercase tracking-wider whitespace-nowrap">
                            Totpunkt-Umsatz
                        </span>
                        <span className="text-lg font-extrabold text-pe-text font-mono-numbers">{formatCurrency(metrics.totpunktMonatsumsatz, currencyCode)}</span>
                    </div>
                    <div className="w-full h-1 bg-[#333] rounded-full overflow-hidden mt-1">
                        <div className="h-full bg-red-500 w-3/4"></div>
                    </div>
                    <p className="text-[10px] text-gray-400 mt-1 text-right">Summe aller Kostenanteile</p>
                </div>
                {!isCollapsed && (
                <div className="p-1 flex-grow bg-pe-tile-header">
                    <div className="grid grid-cols-[140px_50px_80px] items-stretch font-bold border-b border-pe-border-strong"><div className="bg-pe-tile-header dark:bg-[#111] text-pe-text text-[11px] font-bold p-1 pl-2 flex items-center h-7 uppercase">Kostenart</div><div className="bg-pe-tile-header dark:bg-[#111] text-pe-text text-[11px] font-bold p-1 flex items-center justify-end h-7 uppercase">Anteil</div><div className="bg-pe-tile-header dark:bg-[#111] text-pe-text text-[11px] font-bold p-1 flex items-center justify-end h-7 uppercase">Betrag</div></div>
                    <div className="grid grid-cols-[140px_50px_80px] items-stretch border-b border-pe-border-strong bg-pe-sunken dark:bg-[#1a1a1a]"><div className="text-amber-700 dark:text-amber-400 text-[11px] font-bold p-1 pl-2 flex items-center h-7 whitespace-nowrap overflow-hidden">Effektiv Bruttolohn</div><div className="p-1"></div><div className="p-1 flex items-center justify-end"><FormulaDisplay value={metrics.effektiverBruttolohn} type="currency" className="text-xs h-6 p-0 bg-transparent border-none font-mono-numbers text-amber-700 dark:text-amber-400" currencyCode={currencyCode} /></div></div>
                    {renderRow("Mehrwertsteuer", metrics.prozentWerte.mwstProzent, metrics.analyseKosten.mwst)}
                    {renderRow("Materialverbrauch", metrics.prozentWerte.materialProzent, metrics.analyseKosten.material)}
                    {renderRow("Gemeinkosten", metrics.prozentWerte.gemeinkostenProzent, metrics.analyseKosten.gemeinkosten)}
                    {renderRow("Sozialabgaben", metrics.prozentWerte.sozialabgabenProzent, metrics.analyseKosten.sozialabgaben)}
                    {renderRow("Lohnfortzahlung", metrics.prozentWerte.lohnfortzahlungProzent, metrics.analyseKosten.lohnfortzahlung)}
                    {renderRow("Verlust", metrics.prozentWerte.verlustProzent, metrics.analyseKosten.verlust)}
                    {renderRow("Liquidität", metrics.prozentWerte.liquiditaetProzent, metrics.analyseKosten.liquiditaet)}
                </div>
                )}
             </div>
        </div>
    );
};

const MonatstabelleSektion = ({
    title,
    colorConfig,
    halbjahrKey,
    employeeId,
    leistung,
    calculatedData,
    metrics,
    showFormulas,
    bonusFaktoren,
    currencyCode,
    calculations,
    setPerformanceLock,
    isTeamBonusMode = false,
    isFirstEmployee = false,
    festSession,
    onFestSessionUnlock,
    productiveStaff = [],
}: any) => {
    const updateMonatsDatenFeld = useAppStore(state => state.updateMonatsDatenFeld);
    const captureState = useAppStore(state => state.captureState);
    const initializeMitarbeiterLeistung = useAppStore(state => state.initializeMitarbeiterLeistung);
    const isHJ1GesperrtGlobal = useAppStore(state => state.clientData?.isHJ1GesperrtGlobal);
    const isHJ2Freigegeben = useAppStore(state => state.clientData?.isHJ2Freigegeben);
    const isGodMode = !!useAdminStore(state => state.impersonatedClientId);
    // Mandant: HJ1 gesperrt nach HJ2-Freigabe. God-Mode: editierbar + Banner.
    const hj1ClientLocked = isHj1ClientLocked({ isHJ1GesperrtGlobal, isHJ2Freigegeben });
    const isHalbjahrInputLocked = halbjahrKey === 'halbjahr1' && hj1ClientLocked;
    const [passwordPrompt, setPasswordPrompt] = useState<{ isOpen: boolean; index: number | null; value: boolean; coachOnly?: boolean }>({ isOpen: false, index: null, value: false });
    const [bulkModal, setBulkModal] = useState<{ index: number; value: boolean; coachName: string } | null>(null);
    const [bulkSelectedIds, setBulkSelectedIds] = useState<string[]>([]);
    const [bulkBusy, setBulkBusy] = useState(false);

    const {
        lohnfaktorAktiv,
        geraeteListe,
        baseMaterialProzent,
        gemeinkostenPercent,
        avgSozialabgabenPercent,
        lohnfortzahlungPercent,
        verlustPercent,
        settings: storeSettings,
        mwstSatz,
    } = useCalculationsSelector() as any;
    const clientVatExempt = useAppStore((s) => s.clientData?.isVatExempt);
    const resolvedMwstSatz =
        mwstSatz !== undefined && mwstSatz !== null && Number.isFinite(Number(mwstSatz))
            ? Number(mwstSatz)
            : 19;
    const sharedMwst = clientVatExempt ? 1 : 1 + resolvedMwstSatz / 100;

    const sharedCalcCtx = useMemo(() => ({
        mwstFaktor: sharedMwst,
        lohnfaktorAktiv: Number(lohnfaktorAktiv) || 0,
        geraeteListe,
        baseMaterialProzent: Number(baseMaterialProzent) || 0,
        gemeinkostenPercent: Number(gemeinkostenPercent) || 0,
        avgSozialabgabenPercent: Number(avgSozialabgabenPercent) || 0,
        lohnfortzahlungPercent: Number(lohnfortzahlungPercent) || 0,
        verlustPercent: Number(verlustPercent) || 0,
        storeSettings,
    }), [sharedMwst, lohnfaktorAktiv, geraeteListe, baseMaterialProzent, gemeinkostenPercent, avgSozialabgabenPercent, lohnfortzahlungPercent, verlustPercent, storeSettings]);

    // Team-Bonus-Vorschau für DIESE Person (nur Anzeige — schreibt nicht in Personaldaten/Kalkulation)
    const { bonusById, selectedMemberIds } = useTeamBonus();
    const empId = String(employeeId || '');
    const teamBonusMonat =
        isTeamBonusMode && empId && selectedMemberIds.includes(empId)
            ? Number(bonusById[empId]) || 0
            : 0;
    const teamBonusGesamt = teamBonusMonat * COUNT_HJ;

    if (!calculatedData || !leistung) return <div className="text-pe-text">Lade Berechnungen...</div>;

    const openBulkOrApply = (index: number, newValue: boolean, coachName: string) => {
        if (isFirstEmployee && Array.isArray(productiveStaff) && productiveStaff.length > 0) {
            const allIds = productiveStaff.map((s: any) => String(s.id));
            setBulkSelectedIds(allIds);
            setBulkModal({ index, value: newValue, coachName });
            return;
        }
        void applyFestmachen([String(employeeId)], index, newValue, coachName);
    };

    const handleFestmachenClick = (index: number, currentValue: boolean) => {
        const newValue = !currentValue;
        if (festSession?.unlocked) {
            if (newValue && !festSession.coachName) {
                setPasswordPrompt({ isOpen: true, index, value: true, coachOnly: true });
                return;
            }
            openBulkOrApply(index, newValue, festSession.coachName || 'Admin');
            return;
        }
        setPasswordPrompt({ isOpen: true, index, value: newValue, coachOnly: false });
    };

    const applyFestmachen = async (targetIds: string[], targetIndex: number, isLocking: boolean, coachName: string) => {
        captureState();
        setBulkBusy(true);
        try {
            for (const tid of targetIds) {
                initializeMitarbeiterLeistung?.(tid);
                if (isLocking) {
                    const snap =
                        String(tid) === String(employeeId)
                            ? buildMonatsFestsetzungSnapshot(
                                  halbjahrKey === 'halbjahr1' ? calculations.metricsHJ1 : calculations.metricsHJ2,
                                  halbjahrKey === 'halbjahr1' ? calculations.faktorenHJ1 : calculations.faktorenHJ2
                              )
                            : buildSnapshotForEmployeeId(tid, halbjahrKey, sharedCalcCtx);
                    if (!snap) continue;
                    await setPerformanceLock('mitarbeiter', tid, true, snap, coachName, { halbjahrKey, monatIndex: targetIndex });
                } else {
                    await setPerformanceLock('mitarbeiter', tid, false, undefined, 'Admin', { halbjahrKey, monatIndex: targetIndex });
                }
            }
        } finally {
            setBulkBusy(false);
            setBulkModal(null);
        }
    };

    const handlePasswordConfirm = async (password: string, coachName?: string) => {
        if (password !== '90' || passwordPrompt.index === null) {
            alert('Falsches Passwort.');
            setPasswordPrompt({ isOpen: false, index: null, value: false });
            return;
        }
        const isLocking = passwordPrompt.value;
        const targetIndex = passwordPrompt.index;
        if (isLocking && !coachName) {
            alert('Bitte Coach auswählen.');
            return;
        }
        const sessionCoach = isLocking ? (coachName || '') : (festSession?.coachName || '');
        onFestSessionUnlock?.({ unlocked: true, coachName: sessionCoach });
        setPasswordPrompt({ isOpen: false, index: null, value: false });
        openBulkOrApply(targetIndex, isLocking, sessionCoach || coachName || 'Admin');
    };

    const renderUmsatzauslastungSummary = (durchschnitt: any) => {
        const value = durchschnitt.umsatzauslastung;
        const { text: textColor, border: borderColor } = getUmsatzAuslastungStyles(value);
        return (
            <div className="flex flex-col items-center justify-center relative z-20 pointer-events-none w-full" data-tooltip-id="app-tooltip" data-tooltip-content="Ø Umsatzauslastung-Matrix">
                <div className="text-[10px] text-pe-accent-text mb-0.5 uppercase tracking-wide">Ø Umsatzauslastung</div>
                <div className={`w-28 h-9 flex items-center justify-center border-2 rounded bg-pe-tile-header text-lg font-bold font-mono-numbers ${borderColor} ${textColor}`}>
                    {showFormulas ? "(Ist/Soll)*Faktor" : new Intl.NumberFormat('de-DE', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format((value <= 5 ? value : value/100))}
                </div>
            </div>
        );
    };

    const vkFaktorTooltip = `Verhältnis von Verkaufs- zu Bedienumsatz. Grün: >10%, Gelb: 5-10%, Orange: 3-5%, Rot: <3%.`;

    // Feste Pixelbreiten — Tabelle dehnt sich NICHT auf Bildschirmbreite (table-layout:fixed + explizite width)
    const W = { monat: 84, curr: 112, vk: 76, tage: 100, ampel: 112, std: 128, chk: 64, fest: 96 };
    const tableWidthPx = isTeamBonusMode
        ? W.monat + W.curr * 2 + W.vk + W.tage * 2 + W.curr * 7 + W.vk + W.curr + W.chk + W.fest
        : W.monat + W.curr * 2 + W.vk + W.tage * 2 + W.curr * 9 + W.vk + W.curr + W.chk + W.fest;

    const renderColGroup = () => (
        <colgroup>
            <col style={{ width: W.monat }} />
            <col span={2} style={{ width: W.curr }} />
            <col style={{ width: W.vk }} />
            <col span={2} style={{ width: W.tage }} />
            <col span={7} style={{ width: W.curr }} />
            {!isTeamBonusMode && <col span={2} style={{ width: W.curr }} />}
            <col style={{ width: W.vk }} />
            <col style={{ width: W.curr }} />
            <col style={{ width: W.chk }} />
            <col style={{ width: W.fest }} />
        </colgroup>
    );

    const thBase = 'p-1.5 border-r border-pe-border-strong align-bottom leading-tight text-[10px]';
    const thCurr = `${thBase} whitespace-normal`;

    const renderHeader = () => (
        <thead className={`text-pe-text text-xs uppercase ${colorConfig.tableHeaderBg}`}>
            <tr>
                <th className={`${thBase} sticky left-0 z-10 bg-pe-elevated`}>Monat</th>
                <th className={thCurr}>Bedien-<br/>umsatz</th>
                <th className={thCurr}>VK<br/>Umsatz</th>
                <th className={thCurr}>VK-<br/>Faktor</th>
                <th className={`${thCurr} text-blue-700 dark:text-blue-300`}>Urlaub<br/>(Tage)</th>
                <th className={thCurr}>Krank<br/>(Tage)</th>
                <th className={thCurr}>Urlaubs-<br/>ausgleich</th>
                <th className={thCurr}>Gesamt-<br/>umsatz</th>
                <th className={thCurr}>Ampel</th>
                <th className={thCurr}><div>UMSATZ/<br/>STD<span className="block text-orange-700 dark:text-orange-400 font-bold font-mono-numbers normal-case text-[9px] mt-0.5">SOLL {formatCurrency(metrics.sollUmsatzProStunde, currencyCode, 0)}</span></div></th>
                <th className={thCurr}>Kosten-<br/>deckung</th>
                <th className={thCurr}>Soll-<br/>Umsatz</th>
                <th className={thCurr}>(+/-)<br/>Netto</th>
                {!isTeamBonusMode && (
                    <>
                        <th className={`${thCurr} border-l-4 border-pe-border-strong dark:border-[#555]`}><div>Bonus<br/>Bed.<span className="block text-orange-700 dark:text-orange-400 font-bold font-mono-numbers normal-case text-[9px] mt-0.5">({(bonusFaktoren.bedienung * 100).toLocaleString('de-DE')}%)</span></div></th>
                        <th className={thCurr}><div>Bonus<br/>VK<span className="block text-orange-700 dark:text-orange-400 font-bold font-mono-numbers normal-case text-[9px] mt-0.5">({(bonusFaktoren.vk * 100).toLocaleString('de-DE')}%)</span></div></th>
                    </>
                )}
                <th className={`${thCurr} ${isTeamBonusMode ? 'border-l-4 border-pe-border-strong dark:border-[#555]' : ''}`}>Unprod.<br/>(Std)</th>
                <th className={thCurr}>Umsatz<br/>Unprod.</th>
                <th className={`${thBase} border-r-4 border-pe-border-strong dark:border-[#555]`}>Aus-<br/>zahlen</th>
                <th className={`${thBase} pl-2`}>Fest-<br/>machen</th>
            </tr>
        </thead>
    );

    const renderRow = (monat: MonatsDaten, index: number) => {
        const safeMonat = monat || { monat: '', bedienUmsatz: 0, vkUmsatz: 0, urlaubsTage: 0, krankheitsTage: 0, unproduktiveStunden: 0, ueberstundenAuszahlen: false, festmachen: false };
        const calculated = calculatedData.monatsDetails[index] || {};
        
        const handleUpdate = (field: any, value: any) => {
            captureState();
            updateMonatsDatenFeld(employeeId, halbjahrKey, index, field as any, value);
        };
        
        const vkFaktorProzent = (calculated.vkFaktor || 0) * 100;
        
        const activeMetrics = calculated._activeBasisMetrics || metrics;
        const activeFaktoren = calculated._activeBonusFaktoren || bonusFaktoren;

        return (
            <tr key={index} className="border-b border-pe-border-strong hover:bg-pe-hover dark:hover:bg-[#1a1a1a]">
                <td className="p-1 sticky left-0 bg-pe-card z-10 font-bold text-sm text-gray-300">{safeMonat.monat}</td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Erwirtschafteter Bedienumsatz des Mitarbeiters in diesem Monat."><CurrencyInput value={safeMonat.bedienUmsatz} onChange={(v: number) => handleUpdate('bedienUmsatz', v)} currencyCode={currencyCode} readOnly={isHalbjahrInputLocked} /></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Erwirtschafteter Verkaufsumsatz des Mitarbeiters in diesem Monat."><CurrencyInput value={safeMonat.vkUmsatz} onChange={(v: number) => handleUpdate('vkUmsatz', v)} currencyCode={currencyCode} readOnly={isHalbjahrInputLocked} /></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content={vkFaktorTooltip}><FormulaDisplay value={vkFaktorProzent} isPercentage={true} className="h-8" showFormulas={showFormulas} formula="(VK / Bedienung) * 100" textColor={getVkFaktorColor(vkFaktorProzent)} currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Anzahl der genommenen Urlaubstage des Mitarbeiters in diesem Monat."><NumberInput value={safeMonat.urlaubsTage} suffix="Tage" decimalPlaces={1} onChange={(v: number) => handleUpdate('urlaubsTage', v)} currencyCode={currencyCode} readOnly={isHalbjahrInputLocked} /></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Anzahl der Krankheitstage des Mitarbeiters in diesem Monat."><NumberInput value={safeMonat.krankheitsTage} suffix="Tage" decimalPlaces={1} onChange={(v: number) => handleUpdate('krankheitsTage', v)} currencyCode={currencyCode} readOnly={isHalbjahrInputLocked} /></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Errechnet: Urlaubsausgleich basierend auf dem Durchschnittsumsatz."><FormulaDisplay value={calculated.urlaubsAusgleich} type="currency" className="h-8" showFormulas={showFormulas} formula="Ø-Umsatz * Urlaubstage" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Errechnet: Summe aus Bedienung, Verkauf und Urlaubsausgleich."><FormulaDisplay value={calculated.gesamtUmsatzBrutto} type="currency" className="h-8" showFormulas={showFormulas} formula="Bedienung + VK + Ausgleich" currencyCode={currencyCode}/></td>
                <td className="p-1 align-middle"><UmsatzIndicatorWithText umsatz={calculated.gesamtUmsatzBrutto || 0} soll={calculated.angepassterSollUmsatz || 0} kostendeckung={activeMetrics.kostendeckungsumsatz || 0} /></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Errechnet: Gesamtumsatz geteilt durch die produktiven Monatsstunden."><FormulaDisplay value={calculated.umsatzProStunde} type="currency" decimalPlaces={0} className="h-8" showFormulas={showFormulas} formula="Gesamtumsatz / Monatsstunden" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Kalkulierter Umsatz zur reinen Kostendeckung."><FormulaDisplay value={activeMetrics.kostendeckungsumsatz} type="currency" bgColor="bg-pe-tile-header" textColor="text-pe-accent-text" className="h-8" showFormulas={showFormulas} formula="Eff. Brutto * Kostendeckungsfaktor" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Der Soll-Umsatz, bereinigt um unproduktive Stunden."><FormulaDisplay value={calculated.angepassterSollUmsatz} type="currency" bgColor="bg-pe-tile-header" textColor="text-amber-700 dark:text-amber-400" className="h-8" showFormulas={showFormulas} formula="Sollumsatz - unprod. Umsatz" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Differenz zwischen dem erwirtschafteten Netto und dem Sollumsatz."><FormulaDisplay value={calculated.deltaNetto} type="currency" highlightNegative={true} className="h-8" showFormulas={showFormulas} formula="(Gesamtumsatz - Sollumsatz) / MwSt-Faktor" currencyCode={currencyCode}/></td>
                {!isTeamBonusMode && (
                    <>
                        <td className="p-1 border-l-4 border-pe-border-strong dark:border-[#555] cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Errechneter Bonus für den Dienstleistungsumsatz."><FormulaDisplay value={calculated.bonusBedienung} type="currency" highlightNegative={true} className="h-8" showFormulas={showFormulas} formula={`(+/- Netto) * ${activeFaktoren.bedienung * 100}%`} currencyCode={currencyCode}/></td>
                        <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Errechneter Bonus für den Verkaufsumsatz."><FormulaDisplay value={calculated.bonusVK} type="currency" highlightNegative={true} className="h-8" showFormulas={showFormulas} formula={`(VK Netto) * ${activeFaktoren.vk * 100}%`} currencyCode={currencyCode}/></td>
                    </>
                )}
                <td className="p-1 border-l-4 border-pe-border-strong dark:border-[#555] cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Eingabe: Unproduktive Stunden (z.B. für Salonarbeiten)."><NumberInput value={safeMonat.unproduktiveStunden} decimalPlaces={1} onChange={(v: number) => handleUpdate('unproduktiveStunden', v)} currencyCode={currencyCode} readOnly={isHalbjahrInputLocked} /></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Kalkulierter Umsatzverlust durch die unproduktiven Stunden."><FormulaDisplay value={calculated.umsatzUnproduktiv} type="currency" className="h-8" showFormulas={showFormulas} formula="Unprod. Std * Soll-Std-Satz" currencyCode={currencyCode}/></td>
                <td className="p-1 text-center border-r-4 border-pe-border-strong dark:border-[#555] cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Sollen die unproduktiven Stunden ausgezahlt werden? (Wenn aus, wird der Soll-Umsatz gesenkt)."><input type="checkbox" checked={safeMonat.ueberstundenAuszahlen} onChange={(e) => handleUpdate('ueberstundenAuszahlen', e.target.checked)} disabled={isHalbjahrInputLocked} className="form-checkbox h-5 w-5 bg-pe-input dark:bg-black border-pe-border-strong dark:border-[#444] rounded text-blue-600 focus:ring-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"/></td>
                <td className="p-1 text-center pl-2 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Schließt den Monat ab und friert die Basis-Kennzahlen für diesen Monat unwiderruflich ein."><input type="checkbox" checked={safeMonat.festmachen} onChange={() => handleFestmachenClick(index, safeMonat.festmachen)} disabled={isHalbjahrInputLocked} className="form-checkbox h-5 w-5 cursor-pointer bg-pe-input dark:bg-black border-pe-border-strong dark:border-[#444] rounded text-blue-600 focus:ring-0 disabled:opacity-50 disabled:cursor-not-allowed"/></td>
            </tr>
        )
    };

    const renderSummary = () => {
        const s = calculatedData.summary;
        const d = calculatedData.durchschnitt;
        return (
            <tr className={`font-bold ${colorConfig.summaryBg}`}>
                <td className={`p-1 sticky left-0 z-10 ${colorConfig.summaryStickyBg} text-pe-text`}>Gesamt</td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Bedienumsätze im Halbjahr."><FormulaDisplay value={s.bedienUmsatz} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Verkaufsumsätze im Halbjahr."><FormulaDisplay value={s.vkUmsatz} type="currency" currencyCode={currencyCode}/></td>
                <td></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Gesamte Urlaubstage im Halbjahr."><FormulaDisplay value={s.urlaubsTage} decimalPlaces={1} currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Gesamte Krankheitstage im Halbjahr."><FormulaDisplay value={s.krankheitsTage} decimalPlaces={1} currencyCode={currencyCode}/></td>
                <td></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Summe aller Gesamtumsätze im Halbjahr."><FormulaDisplay value={s.gesamtUmsatzBrutto} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 align-middle"><div className="flex items-center justify-center">{(s.gesamtUmsatzBrutto || 0) > 0 ? renderUmsatzauslastungSummary(d) : <div className="h-full w-[100px]"></div>}</div></td>
                <td className="p-1 align-middle text-left">
                    {(s.gesamtUmsatzBrutto || 0) > 0 && (
                        <div className="bg-pe-card dark:bg-[#111] p-1.5 rounded border border-pe-border-strong shadow-lg flex flex-col justify-center text-[9px] text-left leading-tight w-[130px] pointer-events-none cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Ø Umsatzauslastung-Matrix">
                           <div className="text-slate-400 uppercase font-bold mb-1 border-b border-pe-border-strong pb-0.5">Ziel: 70-75%</div>
                           <div className="text-purple-400 font-bold">≥ 85% = Exzellent</div>
                           <div className="text-emerald-400 font-bold">≥ 75% = Sehr Gut</div>
                           <div className="text-lime-400 font-bold">≥ 70% = Gut</div>
                           <div className="text-yellow-400 font-bold">≥ 60% = Akzep.</div>
                           <div className="text-orange-400 font-bold">≥ 50% = Kritisch</div>
                           <div className="text-red-400 font-bold">&lt; 50% = Defizitär</div>
                        </div>
                    )}
                </td>
                <td colSpan={2}></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Summe der Planabweichungen (Netto)."><FormulaDisplay value={s.deltaNetto} type="currency" highlightNegative={true} currencyCode={currencyCode}/></td>
                {!isTeamBonusMode && (
                    <>
                        <td className="p-1 border-l-4 border-pe-border-strong dark:border-[#555] cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Summe Bonus Bedienung."><FormulaDisplay value={s.bonusBedienung} type="currency" highlightNegative={true} currencyCode={currencyCode}/></td>
                        <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Summe Bonus Verkauf."><FormulaDisplay value={s.bonusVK} type="currency" highlightNegative={true} currencyCode={currencyCode}/></td>
                    </>
                )}
                <td className="p-1 border-l-4 border-pe-border-strong dark:border-[#555]"></td>
                <td></td>
                <td className="border-r-4 border-pe-border-strong dark:border-[#555]"></td>
                <td></td>
            </tr>
        );
    };

    const renderDurchschnitt = () => {
        const d = calculatedData.durchschnitt;
        return (
            <tr className={`font-bold ${colorConfig.averageBg}`}>
                <td className={`p-1 sticky left-0 z-10 ${colorConfig.averageStickyBg} text-pe-text`}>Durchschnitt</td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Bedienumsatz."><FormulaDisplay value={d.bedienUmsatz} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Verkaufsumsatz."><FormulaDisplay value={d.vkUmsatz} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content={vkFaktorTooltip}><FormulaDisplay value={(d.vkFaktor||0) * 100} isPercentage={true} textColor={getVkFaktorColor((d.vkFaktor||0) * 100)} currencyCode={currencyCode} /></td>
                <td colSpan={3}></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Gesamtumsatz."><FormulaDisplay value={d.gesamtUmsatzBrutto} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 align-middle border-2 border-amber-400 bg-pe-card dark:bg-[#111]"><UmsatzIndicatorWithText umsatz={d.gesamtUmsatzBrutto||0} soll={d.sollUmsatzMonat||0} kostendeckung={d.kostendeckungsumsatz||0} /></td>
                <td className="p-1 align-middle cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Stundenumsatz."><FormulaDisplay value={d.umsatzProStunde} type="currency" decimalPlaces={0} currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittliche Kostendeckung."><FormulaDisplay value={d.kostendeckungsumsatz} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittlicher Soll-Umsatz."><FormulaDisplay value={d.sollUmsatzMonat} type="currency" currencyCode={currencyCode}/></td>
                <td className="p-1 cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content="Durchschnittliche Planabweichung."><FormulaDisplay value={d.deltaNetto} type="currency" highlightNegative={true} currencyCode={currencyCode}/></td>
                {!isTeamBonusMode && (
                    <>
                        <td className="p-1 border-l-4 border-pe-border-strong dark:border-[#555]"></td>
                        <td className="p-1"></td>
                    </>
                )}
                <td className="p-1 border-l-4 border-pe-border-strong dark:border-[#555]"></td>
                <td></td>
                <td className="border-r-4 border-pe-border-strong dark:border-[#555]"></td>
                <td></td>
            </tr>
        );
    };

    const renderRealeWerte = () => {
        const real = calculatedData.realDurchschnitt;
        if (!real) return null;
        return (
            <tr className="font-bold bg-pe-tile-header border-t border-pe-border-strong">
                <td className="p-1 sticky left-0 z-10 bg-pe-tile-header text-blue-700 dark:text-blue-300 text-xs">Arbeitsleistung Ø</td>
                <td className="p-1 cursor-help" colSpan={2} data-tooltip-id="app-tooltip" data-tooltip-content="Die reale durchschnittliche Arbeitsleistung pro Monat.">
                    <FormulaDisplay value={real.gesamt} type="currency" textColor="text-blue-300" currencyCode={currencyCode} className="font-bold"/>
                </td>
                <td colSpan={isTeamBonusMode ? 14 : 16}></td>
            </tr>
        );
    };

    const renderBonusAuswertungRow = () => {
        const { summary, durchschnitt } = calculatedData;
        // Team-Bonus: Vorschau-Anteil dieser Person aus PE-TeamBonus (nicht in Kalkulation geschrieben)
        const bonusGesamtRaw = isTeamBonusMode ? teamBonusGesamt : (summary.bonusGesamt || 0);
        const bonusGesamt = bonusGesamtRaw > 0 ? bonusGesamtRaw : 0;
        const monatlicheAuszahlung = isTeamBonusMode
            ? (teamBonusMonat > 0 ? teamBonusMonat : 0)
            : (bonusGesamt > 0 ? safeDiv(bonusGesamt, COUNT_HJ) : 0);
        const isSelectedInTeam = isTeamBonusMode && selectedMemberIds.includes(empId);
        const bonusTooltip = isTeamBonusMode
            ? (isSelectedInTeam
                ? 'Team-Bonus-Vorschau Halbjahr (Anteil am Pool) — noch nicht ausgezahlt, nur Anzeige.'
                : 'Diese Person ist im PE-TeamBonus nicht ausgewählt — Vorschau 0.')
            : 'Summe aller kalkulierten Boni.';
        const monatsTooltip = isTeamBonusMode
            ? 'Team-Bonus-Vorschau pro Monat — Auszahlung erst manuell nach dem Halbjahr in den Personaldaten.'
            : 'Monatliche Auszahlung über das Halbjahr.';
        return (
            <tr className="print:break-inside-avoid"><td colSpan={8} className="pt-4 align-top"><div className="flex justify-center items-start h-full"><PerformanceHinweis metrics={metrics} durchschnitt={durchschnitt} currencyCode={currencyCode} /></div></td><td></td><td colSpan={1} className="pt-4 align-top"><div className="flex justify-start items-start h-full">{(durchschnitt.gesamtUmsatzBrutto || 0) > 0 ? (<PerformanceFeedback istUmsatz={durchschnitt.umsatzProStunde} sollUmsatz={metrics.sollUmsatzProStunde} currencyCode={currencyCode} />) : (<div className="h-full w-[150px]"></div>)}</div></td><td></td><td colSpan={3} className="pt-4 align-top"><div className={`bg-pe-tile-header p-3 rounded-md grid grid-cols-2 gap-x-4 gap-y-2 w-[280px] border ${isTeamBonusMode ? 'border-amber-500/40' : 'border border-pe-border dark:border-[#222]'}`}><div className="text-right font-bold text-sm">{isTeamBonusMode ? 'Team-Bonus HJ (Vorschau):' : 'Bonus Gesamt:'}</div><div className="cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content={bonusTooltip}><FormulaDisplay value={bonusGesamt} type="currency" highlightNegative={true} bgColor="bg-[#111]" textColor={isTeamBonusMode ? 'text-amber-400' : 'text-pe-text'} className="h-8" currencyCode={currencyCode} /></div><div className="text-right font-bold text-emerald-400 text-sm">Auszahlung p. Monat:</div><div className="cursor-help" data-tooltip-id="app-tooltip" data-tooltip-content={monatsTooltip}><FormulaDisplay value={monatlicheAuszahlung} type="currency" bgColor="bg-emerald-950/20" textColor="text-emerald-400" className="h-8 border-emerald-500/30" currencyCode={currencyCode} /></div>{isTeamBonusMode && <div className="col-span-2 text-[10px] text-amber-600 dark:text-amber-400 leading-snug mt-1">{isSelectedInTeam ? 'Vorschau aus PE-TeamBonus — nicht in der Kalkulation. Auszahlung manuell nach dem Halbjahr.' : 'Nicht im Team-Bonus ausgewählt — im PE-TeamBonus anhaken, sonst bleibt die Vorschau 0.'}</div>}</div></td><td colSpan={isTeamBonusMode ? 3 : 5}></td></tr>
        )
    }

    const halbjahrData = ensureArr(leistung[halbjahrKey]);

    return (
        <div className="mb-6 carbon-content">
            <PasswordPrompt
                isOpen={passwordPrompt.isOpen}
                onClose={() => setPasswordPrompt({ ...passwordPrompt, isOpen: false })}
                onConfirm={handlePasswordConfirm}
                title={
                    passwordPrompt.coachOnly
                        ? 'Coach wählen (Passwort bereits freigeschaltet)'
                        : passwordPrompt.value
                          ? 'Monat festmachen?'
                          : 'Festsetzung aufheben?'
                }
                requireCoachSelect={passwordPrompt.value === true}
                skipPassword={!!passwordPrompt.coachOnly}
            />
            <FestmachenBulkModal
                isOpen={!!bulkModal}
                monthLabel={ensureArr(leistung[halbjahrKey])[bulkModal?.index ?? 0]?.monat || `Monat ${(bulkModal?.index ?? 0) + 1}`}
                isLocking={!!bulkModal?.value}
                staff={productiveStaff}
                selectedIds={bulkSelectedIds}
                onToggle={(id) =>
                    setBulkSelectedIds((prev) =>
                        prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
                    )
                }
                onSelectAll={() => setBulkSelectedIds(productiveStaff.map((s: any) => String(s.id)))}
                onSelectNone={() => setBulkSelectedIds([])}
                onConfirm={() => {
                    if (!bulkModal) return;
                    void applyFestmachen(bulkSelectedIds, bulkModal.index, bulkModal.value, bulkModal.coachName);
                }}
                onCancel={() => setBulkModal(null)}
                isBusy={bulkBusy}
            />
            {halbjahrKey === 'halbjahr1' && (
                <Hj1MandantLockBanner show={hj1ClientLocked} />
            )}
            {festSession?.unlocked && (
                <div className="mb-2 text-[10px] font-bold uppercase tracking-widest text-emerald-400/90">
                    Festsetzen freigeschaltet — Passwort gilt bis zum Verlassen dieser Seite
                </div>
            )}
            <h4 className={`text-md font-bold p-2 rounded-t-md text-pe-text ${colorConfig.headerBg}`}>{title}</h4>
            <div className="w-fit max-w-full overflow-x-auto pb-2">
                <table className="table-fixed text-center text-sm" style={{ width: tableWidthPx }}>
                    {renderColGroup()}
                    {renderHeader()}
                    <tbody>{halbjahrData.map(renderRow)}{renderSummary()}{renderDurchschnitt()}{renderRealeWerte()}{renderBonusAuswertungRow()}</tbody>
                </table>
            </div>
        </div>
    );
};

const FreischaltungHJ2Sektion = ({ onMandantenFreischalten, onAdminFreischalten, bestaetigung, onBestaetigungChange, navigateTo, isNotifyingCoach }: any) => {
    return (
        <div className="my-6 p-4 border border-pe-border-strong rounded-md carbon-panel bg-pe-card dark:bg-[#030303]">
            <h4 className="text-md font-bold text-pe-text mb-3 px-3 py-2 carbon-weave-bg rounded-lg carbon-content">Freischaltung für das 2. Halbjahr</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 carbon-content">
                <div className="bg-pe-card dark:bg-[#111] p-3 rounded-lg border border-pe-border-strong flex flex-col">
                    <h5 className="font-bold text-emerald-700 dark:text-emerald-400 mb-2">Option 1: Daten fertig — Betreuer melden</h5>
                    <p className="text-sm text-pe-muted dark:text-gray-300 mb-3 flex-grow">Wenn alle Daten sauber eingetragen sind, benachrichtige deinen Betreuer. Die Freischaltung der Kalkulation erfolgt durch den Coach.</p>
                    <label className="flex items-start space-x-3 cursor-pointer mb-2">
                        <input type="checkbox" checked={bestaetigung} onChange={(e) => onBestaetigungChange(e.target.checked)} className="form-checkbox h-5 w-5 text-blue-500 bg-pe-input dark:bg-black border-pe-border-strong dark:border-[#444] rounded mt-1 flex-shrink-0" />
                        <span className="text-sm text-pe-text dark:text-gray-200 font-semibold italic">Ich bestätige, dass meine Datenerfassung für dieses Halbjahr vollständig ist.</span>
                    </label>
                    <button onClick={onMandantenFreischalten} disabled={!bestaetigung || isNotifyingCoach} className="w-full px-4 py-2 rounded-md bg-emerald-600 text-white hover:bg-emerald-500 transition-colors disabled:bg-gray-500 disabled:cursor-not-allowed mt-auto uppercase font-bold text-xs">
                        {isNotifyingCoach ? 'Wird gesendet…' : 'Betreuer benachrichtigen'}
                    </button>
                </div>
                <div className="bg-pe-card dark:bg-[#111] p-3 rounded-lg border border-pe-border-strong flex flex-col">
                    <h5 className="font-bold text-amber-700 dark:text-amber-400 mb-2">Option 2: Es liegen Änderungen vor</h5>
                    <div className="flex-grow">
                        <p className="text-sm text-pe-muted dark:text-gray-300 mb-4">Sollten sich Stammdaten geändert haben, trage sie hier ein. Die Freischaltung macht anschließend dein Betreuer.</p>
                        <button onClick={() => navigateTo('aenderungs-zentrale')} className="w-full text-center block px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-500 transition-colors mb-4 uppercase font-bold text-xs">Änderungen hier eintragen</button>
                    </div>
                    <div className="mt-auto space-y-3 border-t-2 border-pe-border-strong pt-3">
                        <h6 className="font-bold text-pe-text dark:text-gray-300 text-sm">Admin-Dienstleistung (Coach)</h6>
                        <div className="p-3 bg-pe-tile-header rounded-md border border-pe-border dark:border-[#222]">
                            <p className="text-xs text-pe-muted dark:text-gray-400 mb-3">Mit der Freischaltung wird das 1. Halbjahr automatisch gesperrt und die Stammdaten festgeschrieben.</p>
                            <button onClick={onAdminFreischalten} className="w-full px-4 py-2 rounded-md bg-red-900 text-white hover:bg-red-800 transition-colors uppercase font-bold text-xs border border-red-800">Admin-Freischaltung (Passwort)</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HJ2WarningOverlay = ({ onConfirm }: { onConfirm: () => void }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-stone-900/50 dark:bg-black dark:bg-opacity-90 backdrop-blur-sm p-4">
            <div className="bg-red-950 border-4 border-red-600 rounded-xl p-8 max-w-2xl w-full shadow-[0_0_30px_rgba(239,68,68,0.5)] text-center animate-pulse">
                <svg className="w-24 h-24 text-red-500 mx-auto mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
                <h2 className="text-4xl font-extrabold text-white mb-4 uppercase tracking-wider">Achtung: Änderung!</h2>
                <p className="text-xl text-red-100 mb-8 font-semibold">Es wurden Änderungen für das 2. Halbjahr vorgenommen (Admin-Freischaltung) oder Leistungsdaten angepasst.<br/><br/>Bitte überprüfen und passe jetzt zwingend den <span className="text-[#E6C299] underline decoration-4 underline-offset-4">KOSTENDECKUNGSUMSATZ</span> in den Einstellungen an!</p>
                <button onClick={onConfirm} className="w-full py-4 px-6 bg-white text-red-900 font-black text-xl rounded-lg hover:bg-gray-200 transition-transform transform hover:scale-105 shadow-xl">Zu den Kosteneinstellungen (Kostenfaktor) springen</button>
            </div>
        </div>
    );
};

interface LeistungPageProps {
    employeeId: string;
    isFirstEmployee: boolean; 
    firstEmployeeId: string | null;
    navigateTo: (pageKey: string) => void;
}

const LeistungPage: React.FC<LeistungPageProps> = ({ employeeId, firstEmployeeId, navigateTo }) => {
    const clientData = useAppStore(state => state.clientData);
    const soloMode = isSoloModeActive(clientData);

    useEffect(() => {
        if (soloMode) navigateTo('startseite');
    }, [soloMode, navigateTo]);

    if (soloMode) {
        return (
            <div className="p-12 text-center text-slate-400">
                Mitarbeiter-Auswertung ist im Solo-Modus nicht verfügbar.
            </div>
        );
    }

    const initializeMitarbeiterLeistung = useAppStore(state => state.initializeMitarbeiterLeistung);
    
    const { isHJ2Freigegeben, isHJ1GesperrtGlobal, currencyCode, fallbackMwstFaktor, isCostAdjustmentRequired, setCostAdjustmentRequired, setPerformanceLock } = useAppStore(state => ({
        isHJ2Freigegeben: state.clientData?.isHJ2Freigegeben,
        isHJ1GesperrtGlobal: state.clientData?.isHJ1GesperrtGlobal,
        currencyCode: state.settings?.country?.currency || 'EUR',
        fallbackMwstFaktor: state.clientData?.isVatExempt ? 1 : 1 + (state.settings?.country?.MwSt_Satz ?? 19) / 100,
        isCostAdjustmentRequired: state.clientData?.isCostAdjustmentRequired,
        setCostAdjustmentRequired: state.setCostAdjustmentRequired,
        setPerformanceLock: state.setPerformanceLock
    }));
    
    const rawPersonalData = ensureArr(useAppStore(state => state.clientData?.personalData));
    const firstMitarbeiter = rawPersonalData.length > 0 ? rawPersonalData[0] : null;
    const isFirstEmployeeInternal = firstMitarbeiter && employeeId && (String(firstMitarbeiter.id) === String(employeeId));

    const storeCalc = useCalculationsSelector();
    const mwstFaktor =
        storeCalc?.mwstSatz !== undefined && storeCalc?.mwstSatz !== null && Number.isFinite(Number(storeCalc.mwstSatz))
            ? 1 + Number(storeCalc.mwstSatz) / 100
            : fallbackMwstFaktor;
    const calculations = useLeistungCalculations(employeeId, mwstFaktor);
    const clientDataForFreeze = useAppStore(state => state.clientData);
    
    const leistung = useAppStore(state => state.clientData?.mitarbeiterLeistung?.[employeeId] || {});

    const showFormulas = useAppStore(state => state.showFormulas);
    const { setHj2Freigabe, resetFreischaltung } = useAppStore();

    const buildUnternehmerFreezeSnapshot = () => {
        const ud = clientDataForFreeze?.unternehmerData || {};
        const wochensatz = Number(storeCalc.wochensatz) || 4.33;
        const kdFaktor = Number(clientDataForFreeze?.lohnfaktorData?.kostendeckungsfaktor1) || 2.8;
        const wochenstunden = Number(ud.prodWochenstunden) || 0;
        const arbeitstageWoche = Number(ud.prodWochentage) || 0;
        const monatsstunden = wochenstunden * wochensatz;
        const arbeitszeitTag = arbeitstageWoche > 0 ? wochenstunden / arbeitstageWoche : 0;
        const prodUnternehmerlohn = Number(storeCalc.prodUnternehmerlohn) || 0;
        const planumsatzBrutto = Number(storeCalc.erwarteterBruttoUmsatz) || 0;
        const stdLohn = Number(storeCalc.stundenlohnChef) || 0;
        const sollumsatzPStd = Number(storeCalc.bruttoumsatzProStunde) || 0;

        const partners: Record<string, any> = {};
        const pg = clientDataForFreeze?.personengesellschaft;
        if (pg?.aktiv && Array.isArray(pg.partner)) {
            pg.partner.forEach((p: any) => {
                if (!p?.id) return;
                const pWs = Number(p.prodWochenstunden) || 0;
                const pAt = Number(p.prodWochentage) || 1;
                const pMs = pWs * wochensatz;
                const pLohn = (Number(p.entnahme) || 0) + (Number(p.sozialkosten) || 0);
                let expectedBrutto = Number(p.durchschnittsumsatz) || 0;
                if (expectedBrutto === 0) {
                    const activeMonths = (p.monatsUmsaetze || []).filter((m: number) => m > 0);
                    expectedBrutto = activeMonths.length > 0
                        ? activeMonths.reduce((a: number, b: number) => a + b, 0) / activeMonths.length
                        : 0;
                }
                const pSollStd = pMs > 0 ? expectedBrutto / pMs : 0;
                const pAz = pAt > 0 ? pWs / pAt : 0;
                partners[p.id] = {
                    name: p.name || '',
                    prodWochenstunden: pWs,
                    prodWochentage: pAt,
                    prodUnternehmerlohn: pLohn,
                    planumsatzBrutto: expectedBrutto,
                    kostendeckungsumsatz: pLohn * kdFaktor,
                    monatsstunden: pMs,
                    stdLohn: pMs > 0 ? pLohn / pMs : 0,
                    sollumsatzPStd: pSollStd,
                    sollumsatzPStd75: pSollStd / 0.75,
                    sollumsatzProTag: pSollStd * pAz,
                    arbeitszeitTag: pAz,
                };
            });
        }

        return {
            name: clientDataForFreeze?.unternehmername || 'Kein Name',
            prodWochenstunden: wochenstunden,
            prodWochentage: arbeitstageWoche,
            prodUnternehmerlohn,
            planumsatzBrutto,
            kostendeckungsumsatz: prodUnternehmerlohn * kdFaktor,
            monatsstunden,
            stdLohn,
            sollumsatzPStd,
            sollumsatzPStd75: sollumsatzPStd / 0.75,
            sollumsatzProTag: sollumsatzPStd * arbeitszeitTag,
            arbeitszeitTag,
            wochensatz,
            kostendeckungsfaktor1: kdFaktor,
            partners: Object.keys(partners).length > 0 ? partners : undefined,
        };
    };

    const handleAdminFreischaltungAction = () => {
        setHj2Freigabe(true, {
            lohnfaktorAktiv: Number(storeCalc.lohnfaktorAktiv) || undefined,
            unternehmerFreeze: buildUnternehmerFreezeSnapshot(),
        });
    };

    const [bestaetigungKeineAenderung, setBestaetigungKeineAenderung] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const [simulationData, setSimulationData] = useState({ zielStundenlohn: 15, geplanterBonus: 200 });
    const [isPasswordPromptOpen, setPasswordPromptOpen] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState<(() => void) | null>(null);
    const [isNotifyingCoach, setIsNotifyingCoach] = useState(false);

    const [isSummaryOpen, setIsSummaryOpen] = useState(false);
    const [isHistorieOpen, setIsHistorieOpen] = useState(false);
    const [isHistorieHJ2Open, setIsHistorieHJ2Open] = useState(false);

    // Flüchtige God-Mode-Collapse-States (Default aufgeklappt, synchron HJ1+HJ2)
    const [isStammdatenCollapsed, setIsStammdatenCollapsed] = useState(false);
    const [isSollvorgabenCollapsed, setIsSollvorgabenCollapsed] = useState(false);
    const [isBonusCollapsed, setIsBonusCollapsed] = useState(false);
    const [isKostenstrukturCollapsed, setIsKostenstrukturCollapsed] = useState(false);
    const isGodMode = !!useAdminStore((s) => s.impersonatedClientId);

    // Passwort-Session: einmal pro Besuch dieser Leistungsseite (beide Halbjahre)
    const [festSession, setFestSession] = useState<{ unlocked: boolean; coachName: string } | null>(null);

    useEffect(() => {
        if (!isGodMode) {
            setIsStammdatenCollapsed(false);
            setIsSollvorgabenCollapsed(false);
            setIsBonusCollapsed(false);
            setIsKostenstrukturCollapsed(false);
        }
    }, [isGodMode]);

    const productiveStaff = useMemo(
        () =>
            ensureArr(rawPersonalData)
                .filter((p: any) => p?.id)
                .map((p: any) => ({ id: String(p.id), name: String(p.name || 'Ohne Name') })),
        [rawPersonalData]
    );

    const monatstabelleCommonProps = {
        employeeId,
        leistung,
        showFormulas,
        currencyCode,
        calculations,
        setPerformanceLock,
        isTeamBonusMode: Boolean(calculations?.isTeamBonusMode),
        isFirstEmployee: Boolean(isFirstEmployeeInternal),
        festSession,
        onFestSessionUnlock: setFestSession,
        productiveStaff,
    };

    const hasFestmachenMonateHJ1 = useMemo(
        () => ensureArr(leistung.halbjahr1).some((m: any) => m?.festmachen),
        [leistung]
    );

    const hasFestmachenMonateHJ2 = useMemo(
        () => ensureArr(leistung.halbjahr2).some((m: any) => m?.festmachen),
        [leistung]
    );

    const festsetzungsHistorie = useMemo(() => {
        const lockedIndex = resolveLeistungLockedMetricsIndex(leistung);

        const mapEntries = (halbjahrKey: 'halbjahr1' | 'halbjahr2', halbjahrData: any[], halbjahrLabel: string) =>
            ensureArr(halbjahrData)
                .map((m: any, index: number) => ({ m, index }))
                .filter(({ m }) => m?.festmachen)
                .map(({ m, index }) => {
                    const snap = lockedIndex[halbjahrKey]?.[String(index)];
                    return {
                        monat: m.monat || 'Unbekannt',
                        halbjahr: halbjahrLabel,
                        lockedAt: snap?.lockedAt,
                        lockedBy: snap?.lockedBy,
                        snapshot: snap ? {
                            arbeitstage: snap.arbeitstage,
                            wochenstunden: snap.wochenstunden,
                            lohnfaktor: snap.lohnfaktor,
                            sollUmsatzMonat: snap.sollUmsatzMonat,
                            effektiverBruttolohn: snap.effektiverBruttolohn,
                            stdLohnGrund: snap.stdLohnGrund,
                            stdLohnEffektiv: snap.stdLohnEffektiv,
                            stdLohnGesamt: snap.stdLohnGesamt,
                        } : undefined,
                    };
                });

        return {
            hj1Entries: mapEntries('halbjahr1', leistung.halbjahr1, '1. Halbjahr'),
            hj2Entries: mapEntries('halbjahr2', leistung.halbjahr2, '2. Halbjahr'),
            employeeName: calculations?.employee?.name || '',
        };
    }, [leistung, calculations]);

    const normalizedMonthsForMA = useMemo(() => {
        if (!calculations) return [];
        return normalizeMonthsForMA(
            calculations.processedHJ1?.monatsDetails || [],
            calculations.processedHJ2?.monatsDetails || [],
            ensureArr(leistung.halbjahr1),
            ensureArr(leistung.halbjahr2),
            mwstFaktor
        );
    }, [calculations, leistung, mwstFaktor]);

    const stammdatenMA = useMemo(() => {
        if (!calculations) return { wochenstunden: 0, arbeitstage: 5, monatsStunden: 0, grundlohn: 0, effektiverBruttolohn: 0, gesamtlohnBrutto: 0, stdLohnGrund: 0, stdLohnGesamt: 0, lohnfaktorSoll: 0, kostendeckungsFaktor: 0, salonStundensatz: 0 };
        const { employeeHJ1, metricsHJ1 } = calculations;
        return {
            wochenstunden: employeeHJ1?.wochenstunden || 0,
            arbeitstage: employeeHJ1?.arbeitstage || 5, 
            monatsStunden: metricsHJ1?.monatsStunden || 0,
            grundlohn: metricsHJ1?.grundgehalt || 0,
            effektiverBruttolohn: metricsHJ1?.effektiverBruttolohn || 0,
            gesamtlohnBrutto: metricsHJ1?.gesamtlohnBrutto || 0,
            stdLohnGrund: metricsHJ1?.stdLohnGrund || 0,
            stdLohnGesamt: metricsHJ1?.stdLohnGesamt || 0,
            lohnfaktorSoll: safeDiv(metricsHJ1?.sollUmsatzMonat, metricsHJ1?.effektiverBruttolohn),
            kostendeckungsFaktor: metricsHJ1?.kostendeckungsfaktor || 2.8,
            salonStundensatz: metricsHJ1?.salonStundensatz || 0
        };
    }, [calculations]);

    useEffect(() => { if (isCostAdjustmentRequired) setShowWarning(true); else setShowWarning(false); }, [isCostAdjustmentRequired]);

    useEffect(() => { if (employeeId) initializeMitarbeiterLeistung(employeeId); }, [employeeId, initializeMitarbeiterLeistung]);

    const withAdminPassword = (action: () => void) => { setActionToConfirm(() => action); setPasswordPromptOpen(true); };
    const handlePasswordConfirm = (password: string) => { if (password === '90') { if (actionToConfirm) actionToConfirm(); } else { alert("Falsches Passwort."); } setActionToConfirm(null); setPasswordPromptOpen(false); };
    const handleConfirmWarning = () => { setCostAdjustmentRequired(false); setShowWarning(false); navigateTo('lohnfaktor'); };
    
    const handleMandantenFreischaltenTrigger = async () => {
        if (!bestaetigungKeineAenderung) return;
        if (!window.confirm('Betreuer jetzt benachrichtigen, dass deine Daten prüfbereit sind?')) return;

        setIsNotifyingCoach(true);
        try {
            const { auth, db } = await import('../config/firebase');
            const { collection, addDoc, serverTimestamp, doc, updateDoc } = await import('firebase/firestore');
            const { resolveClientCoach } = await import('../utils/teamResolve');
            const adminStore = (await import('../store/adminStore')).default;
            const impersonatedClientId = adminStore.getState().impersonatedClientId;
            const targetUid = impersonatedClientId || auth.currentUser?.uid;
            if (!targetUid) throw new Error('Nicht eingeloggt');

            const team = useAppStore.getState().team || [];
            const teamRegistry = useAppStore.getState().teamRegistry || [];
            const cd = useAppStore.getState().clientData || {};
            const coach = resolveClientCoach(cd, team, teamRegistry);
            const coachEmail = String(coach?.email || '').trim() || 'erfolg@friseur-coaching.de';
            const salonName = cd.firmenname || cd.salonname || 'Mandant';
            const jahr =
                (typeof window !== 'undefined' && localStorage.getItem('CURRENT_YEAR')) ||
                String(new Date().getFullYear());

            await addDoc(collection(db, 'mail_queue'), {
                email: coachEmail,
                type: 'hj2_freischaltung_request',
                subject: `HJ2-Freischaltung angefragt: ${salonName}`,
                participantName: salonName,
                salonName,
                mandantNr: cd.mandantNr || '',
                jahr,
                applicantUid: targetUid,
                coachName: coach?.name || '',
                message:
                    'Der Mandant meldet: Datenerfassung abgeschlossen. Bitte Kalkulation / 2. Halbjahr prüfen und freischalten.',
                appBaseUrl: window.location.origin,
                status: 'pending',
                createdAt: serverTimestamp(),
            });

            try {
                await updateDoc(doc(db, 'kalkulation_mandanten', targetUid), {
                    hj2FreischaltungAngefragt: true,
                    hj2FreischaltungAngefragtAm: new Date().toISOString(),
                });
            } catch (_) { /* optional flag */ }

            alert('Betreuer wurde benachrichtigt. Die Freischaltung erfolgt nach Prüfung durch deinen Coach.');
            setBestaetigungKeineAenderung(false);
        } catch (err) {
            console.error('HJ2 Betreuer-Mail fehlgeschlagen:', err);
            alert('Benachrichtigung fehlgeschlagen. Bitte später erneut versuchen.');
        } finally {
            setIsNotifyingCoach(false);
        }
    };

    if (!calculations || !leistung) return <div className="p-6 text-pe-text font-mono-numbers">Lade Mitarbeiterdaten...</div>;
    const { metricsHJ1, processedHJ1, metricsHJ2, processedHJ2, employee, employeeHJ1, metricsJahr, faktorenHJ1, faktorenHJ2 } = calculations;
    const tatsaechlicherGewinnHJ1 = (processedHJ1?.durchschnitt?.gesamtUmsatzBrutto || 0) > 0 ? processedHJ1.durchschnitt.gesamtUmsatzBrutto - (metricsHJ1.totpunktMonatsumsatz || 0) : 0;
    const tatsaechlicherGewinnHJ2 = (processedHJ2?.durchschnitt?.gesamtUmsatzBrutto || 0) > 0 ? processedHJ2.durchschnitt.gesamtUmsatzBrutto - (metricsHJ2.totpunktMonatsumsatz || 0) : 0;
    
    const handleNavigate = () => { if (firstMitarbeiter) navigateTo(`leistung-${firstMitarbeiter.id}`); };

    return (
        <div id="main-scroll-container" className="relative w-full min-h-[calc(100vh-160px)] h-auto bg-deep-space text-slate-200 overflow-visible font-sans selection:bg-phantom-gold selection:text-black pb-28">
            <DashboardStyles />
            {showWarning && <HJ2WarningOverlay onConfirm={handleConfirmWarning} />}
            <PasswordPrompt isOpen={isPasswordPromptOpen} onClose={() => setPasswordPromptOpen(false)} onConfirm={handlePasswordConfirm} title="Coach-Passwort eingeben" />

            {/* Breite = Inhalt + moderater rechter Scroll-Puffer */}
            <div
                className="p-6 pb-28"
                style={{ width: 'max-content', minWidth: '100%', paddingRight: '9rem' }}
            >
                
                <div className="sticky top-0 md:top-28 z-30 flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-center gap-4 mb-6 carbon-weave-bg border border-pe-border dark:border-[#2a2a2a] p-5 rounded-xl w-fit max-w-full bg-pe-card dark:bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg">
                    <div>
                        <h2 className="text-xl font-black tracking-tight text-pe-text uppercase">Performance Analyse</h2>
                        <p className="text-sm text-pe-muted dark:text-slate-400 font-medium">Detaillierte ROI- und Effizienz-Auswertung für <span className="text-pe-accent-text">{employee.name}</span></p>
                    </div>
                    <button
                        type="button"
                        onClick={() => {
                            navigateTo('datenuebersicht');
                            setTimeout(() => {
                                document.getElementById('provision-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 200);
                        }}
                        className="shrink-0 bg-pe-elevated dark:bg-[#0a0a0a] hover:bg-pe-hover dark:hover:bg-[#111] text-pe-accent-text font-bold py-2.5 px-5 rounded-xl transition-all flex items-center justify-center gap-2 border border-pe-border dark:border-[#222] shadow-lg"
                        data-tooltip-id="app-tooltip"
                        data-tooltip-content="Öffnet die Datenübersicht — dort stellst du Provision % (Dienstleistung & Verkauf) zentral für alle Mitarbeiter ein."
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="5" x2="5" y2="19"></line>
                            <circle cx="6.5" cy="6.5" r="2.5"></circle>
                            <circle cx="17.5" cy="17.5" r="2.5"></circle>
                        </svg>
                        Provision % einstellen
                    </button>
                    <button
                        type="button"
                        onClick={() => setIsSummaryOpen(true)}
                        title="Mitarbeiteranalyse öffnen"
                        data-tooltip-id="app-tooltip"
                        data-tooltip-content="Mitarbeiteranalyse: Status, Ziele und Maßnahmen für das Mitarbeitergespräch."
                        className="shrink-0 bg-[#E6C299]/15 hover:bg-[#E6C299]/25 text-[#E6C299] font-bold py-2.5 px-5 rounded-xl transition-all flex items-center justify-center gap-2 border border-[#E6C299]/50 shadow-lg"
                    >
                        <span aria-hidden>📋</span>
                        Mitarbeiteranalyse
                    </button>
                </div>

                <main>
                    <div className="pt-2">
                        <Hj1MandantLockBanner
                            show={Boolean(isHJ1GesperrtGlobal) && Boolean(isHJ2Freigegeben)}
                        />
                        <StammdatenCompactSektion 
                            title="Stammdaten 1. Halbjahr" 
                            metrics={metricsHJ1} 
                            employee={employeeHJ1} 
                            showFormulas={showFormulas} 
                            currencyCode={currencyCode} 
                            leistung={leistung} 
                            employeeId={employeeId}
                            isCollapsed={isStammdatenCollapsed}
                            onToggleCollapse={() => setIsStammdatenCollapsed((v) => !v)}
                            isGodMode={isGodMode}
                            isStammdatenLocked={Boolean(isHJ1GesperrtGlobal) && Boolean(isHJ2Freigegeben)}
                        />
                        <div className="flex flex-row gap-4 items-start pb-2 mb-6">
                            <div className="flex-none"><KostenstrukturAnalyseSektion title="Kostenstruktur & Totpunkt HJ1 (Info)" metrics={metricsHJ1} currencyCode={currencyCode} isCollapsed={isKostenstrukturCollapsed} onToggleCollapse={() => setIsKostenstrukturCollapsed((v) => !v)} isGodMode={isGodMode} /></div>
                            <div className="flex flex-col gap-4">
                                <SollvorgabenCompactSektion title="Sollvorgaben & Kennzahlen HJ1" metrics={metricsHJ1} tatsaechlicherGewinn={tatsaechlicherGewinnHJ1} currencyCode={currencyCode} isCollapsed={isSollvorgabenCollapsed} onToggleCollapse={() => setIsSollvorgabenCollapsed((v) => !v)} isGodMode={isGodMode} />
                                <div className="flex flex-row flex-wrap items-end gap-4">
                                    <BonusSimulationCompactSektion title="Bonus-Umwandlung in Gehalt" simulationData={simulationData} setSimulationData={setSimulationData} metricsJahr={metricsJahr} currencyCode={currencyCode} isCollapsed={isBonusCollapsed} onToggleCollapse={() => setIsBonusCollapsed((v) => !v)} isGodMode={isGodMode} />
                                    {hasFestmachenMonateHJ1 && (
                                        <button
                                            type="button"
                                            onClick={() => setIsHistorieOpen(true)}
                                            className="shrink-0 bg-pe-tile-header dark:bg-[#1a1a1a] hover:bg-pe-hover dark:hover:bg-[#222] text-pe-accent-text font-bold py-3 px-6 rounded-xl transition-all flex items-center justify-center gap-3 border border-pe-border-strong shadow-lg"
                                        >
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="12" cy="12" r="10"></circle>
                                                <polyline points="12 6 12 12 16 14"></polyline>
                                            </svg>
                                            Festsetzungs-Historie
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <MonatstabelleSektion
                            title="1. Halbjahr - Detailansicht"
                            colorConfig={{ headerBg: 'bg-pe-card', border: 'border-pe-border-strong', tableHeaderBg: 'bg-pe-elevated', tableBorder: 'border-pe-border-strong', summaryBg: 'bg-emerald-950/20', summaryStickyBg: 'bg-pe-elevated', averageBg: 'bg-pe-card', averageStickyBg: 'bg-pe-elevated' }}
                            halbjahrKey="halbjahr1"
                            calculatedData={processedHJ1}
                            metrics={metricsHJ1}
                            bonusFaktoren={faktorenHJ1}
                            {...monatstabelleCommonProps}
                        />
                    </div>
                </main>
            
                {isHJ2Freigegeben ? (
                    <main>
                        <div className="pt-6 border-t-4 border-pe-border-strong mt-8">
                            
                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
                                <h3 className="text-xl font-bold text-pe-text uppercase tracking-widest">Bereich 2. Halbjahr (Aktiv)</h3>
                            </div>

                            <StammdatenCompactSektion 
                                title="Stammdaten 2. Halbjahr" 
                                metrics={metricsHJ2} 
                                employee={employee} 
                                showFormulas={showFormulas} 
                                currencyCode={currencyCode} 
                                leistung={leistung}
                                employeeId={employeeId}
                                isCollapsed={isStammdatenCollapsed}
                                onToggleCollapse={() => setIsStammdatenCollapsed((v) => !v)}
                                isGodMode={isGodMode}
                            />
                            <div className="flex flex-row gap-4 items-start pb-2 mb-6">
                                <div className="flex-none"><KostenstrukturAnalyseSektion title="Kostenstruktur & Totpunkt HJ2 (Info)" metrics={metricsHJ2} currencyCode={currencyCode} isCollapsed={isKostenstrukturCollapsed} onToggleCollapse={() => setIsKostenstrukturCollapsed((v) => !v)} isGodMode={isGodMode} /></div>
                                <div className="flex flex-col gap-4">
                                    <SollvorgabenCompactSektion title="Sollvorgaben & Kennzahlen HJ2" metrics={metricsHJ2} tatsaechlicherGewinn={tatsaechlicherGewinnHJ2} currencyCode={currencyCode} isCollapsed={isSollvorgabenCollapsed} onToggleCollapse={() => setIsSollvorgabenCollapsed((v) => !v)} isGodMode={isGodMode} />
                                    <div className="flex flex-row flex-wrap items-end gap-4">
                                        <BonusSimulationCompactSektion title="Bonus-Umwandlung in Gehalt (HJ2)" simulationData={simulationData} setSimulationData={setSimulationData} metricsJahr={metricsJahr} currencyCode={currencyCode} isCollapsed={isBonusCollapsed} onToggleCollapse={() => setIsBonusCollapsed((v) => !v)} isGodMode={isGodMode} />
                                        {hasFestmachenMonateHJ2 && (
                                            <button
                                                type="button"
                                                onClick={() => setIsHistorieHJ2Open(true)}
                                                className="shrink-0 bg-pe-tile-header dark:bg-[#1a1a1a] hover:bg-pe-hover dark:hover:bg-[#222] text-pe-accent-text font-bold py-3 px-6 rounded-xl transition-all flex items-center justify-center gap-3 border border-pe-border-strong shadow-lg"
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <polyline points="12 6 12 12 16 14"></polyline>
                                                </svg>
                                                Festsetzungs-Historie
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <MonatstabelleSektion
                                title="2. Halbjahr - Detailansicht"
                                colorConfig={{ headerBg: 'bg-pe-card', border: 'border-pe-border-strong', tableHeaderBg: 'bg-pe-elevated', tableBorder: 'border-pe-border-strong', summaryBg: 'bg-emerald-950/20', summaryStickyBg: 'bg-pe-elevated', averageBg: 'bg-pe-card', averageStickyBg: 'bg-pe-elevated' }}
                                halbjahrKey="halbjahr2"
                                calculatedData={processedHJ2}
                                metrics={metricsHJ2}
                                bonusFaktoren={faktorenHJ2}
                                {...monatstabelleCommonProps}
                            />
                        </div>
                    </main>
                ) : isFirstEmployeeInternal ? (
                    <div className="max-w-5xl"><FreischaltungHJ2Sektion bestaetigung={bestaetigungKeineAenderung} onBestaetigungChange={setBestaetigungKeineAenderung} onMandantenFreischalten={handleMandantenFreischaltenTrigger} onAdminFreischalten={() => withAdminPassword(handleAdminFreischaltungAction)} navigateTo={navigateTo} isNotifyingCoach={isNotifyingCoach} /></div>
                ) : (
                    <div className="max-w-2xl mx-auto text-center p-8 bg-pe-card dark:bg-[#111] border border-pe-border-strong rounded-lg mt-6"><h2 className="text-2xl font-bold text-pe-text mb-4 uppercase tracking-widest">Das 2. Halbjahr ist noch nicht freigeschaltet.</h2><p className="text-pe-muted dark:text-slate-400 mb-6 font-medium">Die Freischaltung muss zentral durch den Administrator oder den primären Mandanten auf der Seite von Mitarbeiter 1 erfolgen.</p><button onClick={handleNavigate} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-md transition-colors">Zur zentralen Freischaltung (Mitarbeiter 1)</button></div>
                )}

                {isFirstEmployeeInternal && (<div className="px-6 pb-6 mt-4"><button onClick={() => withAdminPassword(() => resetFreischaltung())} className="text-xs text-stone-500 dark:text-slate-500 hover:text-pe-text underline">Freischaltung zurücksetzen (Admin)</button></div>)}

                {/* Sichtbarer Scroll-Puffer rechts — Checkboxen freischieben */}
                <div className="h-4 w-36" aria-hidden />
            </div>

            <ExecutiveSummaryModal 
                isOpen={isSummaryOpen} 
                onClose={() => setIsSummaryOpen(false)} 
                title={employee.name}
                currencyCode={currencyCode}
                mwstFaktor={mwstFaktor}
                stammdaten={stammdatenMA}
                rawMonthsData={normalizedMonthsForMA}
                isHJ2Freigegeben={isHJ2Freigegeben}
            />

            <FestsetzungsHistorieModal
                isOpen={isHistorieOpen}
                onClose={() => setIsHistorieOpen(false)}
                currencyCode={currencyCode}
                employeeName={festsetzungsHistorie.employeeName}
                hj1Entries={festsetzungsHistorie.hj1Entries}
            />

            <FestsetzungsHistorieModalHJ2
                isOpen={isHistorieHJ2Open}
                onClose={() => setIsHistorieHJ2Open(false)}
                currencyCode={currencyCode}
                employeeName={festsetzungsHistorie.employeeName}
                hj2Entries={festsetzungsHistorie.hj2Entries}
            />

        </div>
    );
};

export default LeistungPage;